// =============================================================================
// THREADFUELED TEAM PORTAL — team-portal-logic.js
// v3.3 — multi-player cart, line item properties, order number tracking
// =============================================================================

(function () {
'use strict';

// ── CSS injection ────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Inter:wght@400;500;600;700&display=swap');

  :root {
    --a:    #0D9488;
    --a2:   #0f766e;
    --ad:   rgba(13,148,136,0.12);
    --ab:   rgba(13,148,136,0.25);
    --bg:   #080808;
    --s1:   #0f0f0f;
    --s2:   #141414;
    --s3:   #1a1a1a;
    --s4:   #222;
    --b:    rgba(255,255,255,0.07);
    --b2:   rgba(255,255,255,0.14);
    --t:    #ffffff;
    --tm:   rgba(255,255,255,0.55);
    --td:   rgba(255,255,255,0.30);
    --ease: cubic-bezier(0.16,1,0.3,1);
    --amber: #f59e0b;
    --red:   #f87171;
    --green: #34d399;
  }

  #tf-portal-root { font-family:'Inter',sans-serif; }
  #tf-portal-loading { display:none !important; }

  .tf { background:var(--bg); color:var(--t); min-height:100vh; overflow-x:hidden; }
  .tf * { box-sizing:border-box; margin:0; padding:0; }
  .tf button { cursor:pointer; font-family:inherit; border:none; background:none; }
  .tf input, .tf select, .tf textarea { font-family:inherit; }
  .tf a { color:inherit; text-decoration:none; }

  .tf-bg {
    position:fixed; inset:0; pointer-events:none; z-index:0;
    background-image:
      linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
    background-size:52px 52px;
  }

  .tf-screen { position:relative; z-index:1; }
  .tf-fade-in { animation:tfFadeIn 0.5s var(--ease) both; }
  .tf-slide-up { animation:tfSlideUp 0.5s var(--ease) both; }
  @keyframes tfFadeIn  { from{opacity:0} to{opacity:1} }
  @keyframes tfSlideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }

  .tf-spin { animation:tfSpin 0.8s linear infinite; }
  @keyframes tfSpin { to{transform:rotate(360deg)} }

  .tf-toasts { position:fixed; top:20px; right:20px; z-index:999; display:flex; flex-direction:column; gap:8px; pointer-events:none; }
  .tf-toast {
    background:var(--s1); border:1px solid var(--b2); border-radius:14px;
    padding:12px 16px; display:flex; align-items:flex-start; gap:10px;
    min-width:260px; max-width:340px; box-shadow:0 12px 40px rgba(0,0,0,0.6);
    animation:tfToastIn 0.35s var(--ease); pointer-events:all;
  }
  @keyframes tfToastIn { from{opacity:0;transform:translateX(110%)} to{opacity:1;transform:translateX(0)} }
  .tf-toast-ico { width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:0.75rem; flex-shrink:0; }
  .tf-toast-ico.ok   { background:rgba(52,211,153,0.15); color:var(--green); }
  .tf-toast-ico.err  { background:rgba(248,113,113,0.15); color:var(--red); }
  .tf-toast-ico.info { background:var(--ad); color:var(--a); }
  .tf-toast-ico.warn { background:rgba(245,158,11,0.15); color:var(--amber); }
  .tf-toast-title { font-size:0.82rem; font-weight:700; color:var(--t); }
  .tf-toast-body  { font-size:0.72rem; color:var(--td); margin-top:2px; line-height:1.4; }

  .tf-modal-ov {
    position:fixed; inset:0; background:rgba(0,0,0,0.75); z-index:200;
    display:flex; align-items:center; justify-content:center; padding:20px;
    backdrop-filter:blur(6px); animation:tfFadeIn 0.25s ease;
  }
  .tf-modal {
    background:var(--s1); border:1px solid var(--b2); border-radius:20px;
    padding:32px; max-width:420px; width:100%;
    box-shadow:0 40px 80px rgba(0,0,0,0.6);
    animation:tfSlideUp 0.35s var(--ease);
  }
  .tf-modal-title { font-family:'Oswald',sans-serif; font-size:1.3rem; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; margin-bottom:8px; }
  .tf-modal-sub   { font-size:0.83rem; color:var(--td); line-height:1.55; margin-bottom:22px; }
  .tf-modal-btns  { display:flex; gap:10px; margin-top:22px; }

  .tf-btn {
    height:44px; padding:0 20px; border-radius:11px;
    font-family:'Oswald',sans-serif; font-size:0.82rem; font-weight:700;
    letter-spacing:0.12em; text-transform:uppercase;
    display:inline-flex; align-items:center; justify-content:center; gap:8px;
    transition:all 0.22s ease; cursor:pointer; border:none;
  }
  .tf-btn i { font-size:0.8rem; }
  .tf-btn.prim  { background:var(--a); color:white; }
  .tf-btn.prim:hover:not(:disabled)  { filter:brightness(112%); transform:translateY(-1px); box-shadow:0 6px 20px rgba(13,148,136,0.3); }
  .tf-btn.ghost { background:transparent; border:1px solid var(--b2); color:var(--tm); }
  .tf-btn.ghost:hover:not(:disabled) { color:var(--t); border-color:rgba(255,255,255,0.3); background:var(--s2); }
  .tf-btn.dark  { background:var(--s3); border:1px solid var(--b); color:var(--tm); }
  .tf-btn.dark:hover:not(:disabled)  { background:var(--s4); color:var(--t); }
  .tf-btn.danger{ background:transparent; border:1px solid rgba(248,113,113,0.25); color:var(--red); }
  .tf-btn.danger:hover:not(:disabled){ background:rgba(248,113,113,0.08); }
  .tf-btn:disabled { opacity:0.45; cursor:not-allowed; transform:none !important; }
  .tf-btn.sm { height:36px; padding:0 14px; font-size:0.72rem; }
  .tf-btn.lg { height:52px; padding:0 28px; font-size:0.9rem; }
  .tf-btn.full { width:100%; }

  .tf-inp, .tf-sel, .tf-ta {
    width:100%; background:var(--s2); border:1.5px solid var(--b);
    border-radius:10px; color:var(--t); font-family:'Inter',sans-serif;
    font-size:0.88rem; padding:10px 14px; outline:none;
    transition:border-color 0.2s, box-shadow 0.2s;
  }
  .tf-inp { height:42px; }
  .tf-inp:focus, .tf-sel:focus, .tf-ta:focus { border-color:var(--a); box-shadow:0 0 0 3px var(--ad); }
  .tf-inp::placeholder, .tf-ta::placeholder { color:rgba(255,255,255,0.2); }
  .tf-ta { resize:vertical; min-height:80px; line-height:1.5; }
  .tf-sel option { background:var(--s2); }
  .tf-sel { height:42px; appearance:none; padding-right:36px;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.4)' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
    background-repeat:no-repeat; background-position:right 10px center; }

  .tf-label { display:block; font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.12em; color:var(--td); margin-bottom:6px; }
  .tf-field { margin-bottom:14px; }
  .tf-fg2 { display:grid; grid-template-columns:1fr 1fr; gap:12px; }

  .tf-badge { display:inline-block; padding:3px 9px; border-radius:20px; font-size:0.62rem; font-weight:700; text-transform:uppercase; letter-spacing:0.07em; white-space:nowrap; }
  .tf-badge.paid    { background:rgba(52,211,153,0.12); color:var(--green); border:1px solid rgba(52,211,153,0.25); }
  .tf-badge.pending { background:rgba(245,158,11,0.12); color:var(--amber); border:1px solid rgba(245,158,11,0.25); }
  .tf-badge.in-cart { background:rgba(96,165,250,0.12); color:#60a5fa; border:1px solid rgba(96,165,250,0.25); }
  .tf-badge.core    { background:var(--ad); color:var(--a); border:1px solid var(--ab); }
  .tf-badge.optional{ background:rgba(255,255,255,0.05); color:var(--tm); border:1px solid var(--b); }

  .tf-card { background:var(--s1); border:1px solid var(--b); border-radius:14px; }

  .tf-topbar {
    background:var(--s1); border-bottom:1px solid var(--b);
    height:58px; padding:0 clamp(1rem,4vw,2rem);
    display:flex; align-items:center; justify-content:space-between;
    position:sticky; top:0; z-index:80;
  }
  .tf-brand { font-family:'Oswald',sans-serif; font-size:1rem; font-weight:700; text-transform:uppercase; letter-spacing:0.1em; display:flex; align-items:center; gap:8px; }
  .tf-brand .dot { width:8px; height:8px; border-radius:50%; background:var(--a); flex-shrink:0; }

  .tf-sec-lbl { font-family:'Oswald',sans-serif; font-size:0.7rem; font-weight:600; text-transform:uppercase; letter-spacing:0.14em; color:var(--td); display:flex; align-items:center; gap:8px; margin-bottom:14px; }
  .tf-sec-lbl::before { content:''; width:3px; height:14px; background:var(--a); border-radius:2px; flex-shrink:0; }

  .tf-status { display:inline-flex; align-items:center; gap:5px; font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.07em; }
  .tf-status::before { content:''; width:6px; height:6px; border-radius:50%; flex-shrink:0; }
  .tf-status.paid    { color:var(--green); }
  .tf-status.paid::before    { background:var(--green); }
  .tf-status.pending { color:var(--amber); }
  .tf-status.pending::before { background:var(--amber); animation:tfPulse 1.8s infinite; }
  .tf-status.in-cart { color:#60a5fa; }
  .tf-status.in-cart::before { background:#60a5fa; }

  @keyframes tfPulse { 0%,100%{opacity:1} 50%{opacity:0.4} }

  .tf-ring-wrap { position:relative; display:inline-flex; align-items:center; justify-content:center; }
  .tf-ring-svg { transform:rotate(-90deg); }
  .tf-ring-track { fill:none; stroke:rgba(255,255,255,0.06); }
  .tf-ring-fill  { fill:none; stroke-linecap:round; transition:stroke-dashoffset 1s var(--ease), stroke 0.5s ease; }
  .tf-ring-center { position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; }

  .tf-prog-track { height:5px; background:rgba(255,255,255,0.06); border-radius:3px; overflow:hidden; }
  .tf-prog-fill  { height:100%; border-radius:3px; background:var(--a); transition:width 1s var(--ease); }
  .tf-prog-fill.amber { background:var(--amber); }
  .tf-prog-fill.red   { background:var(--red); }

  .tf-player-card {
    background:var(--s1); border:1px solid var(--b); border-radius:14px;
    padding:20px; cursor:pointer; transition:all 0.22s ease;
    display:flex; flex-direction:column; align-items:center; text-align:center;
    position:relative; overflow:hidden;
    -webkit-tap-highlight-color:transparent;
  }
  .tf-player-card::before { content:''; position:absolute; bottom:0; left:0; right:0; height:3px; background:var(--a); transform:scaleX(0); transition:transform 0.22s ease; border-radius:0 0 14px 14px; }
  .tf-player-card:hover::before, .tf-player-card:active::before { transform:scaleX(1); }
  .tf-player-card:hover { border-color:var(--ab); transform:translateY(-2px); box-shadow:0 8px 28px rgba(0,0,0,0.4); }
  .tf-player-card:active { transform:translateY(0); }
  .tf-player-card.done { background:var(--s2); opacity:0.5; cursor:not-allowed; }
  .tf-player-card.done:hover { transform:none; box-shadow:none; border-color:var(--b); }
  .tf-player-card.done::before { display:none; }
  .tf-player-card.in-cart { border-color:rgba(96,165,250,0.3); }
  .tf-player-num { font-family:'Oswald',sans-serif; font-size:2.8rem; font-weight:700; color:var(--a); line-height:1; margin-bottom:8px; }
  .tf-player-card.done .tf-player-num { color:rgba(255,255,255,0.2); }
  .tf-player-name { font-size:0.82rem; font-weight:600; color:var(--t); text-transform:uppercase; letter-spacing:0.06em; }

  .tf-size-btn {
    padding:14px 10px; border:1.5px solid var(--b); border-radius:10px;
    background:var(--s2); color:var(--tm); font-family:'Oswald',sans-serif;
    font-size:0.85rem; font-weight:700; letter-spacing:0.08em; text-transform:uppercase;
    cursor:pointer; transition:all 0.18s ease; text-align:center;
  }
  .tf-size-btn:hover { border-color:var(--a); color:var(--t); background:var(--ad); }
  .tf-size-btn.on { border-color:var(--a); background:var(--a); color:white; box-shadow:0 4px 14px rgba(13,148,136,0.35); }
  .tf-size-btn.unavail { opacity:0.3; cursor:not-allowed; text-decoration:line-through; }

  .tf-prod-card {
    background:var(--s1); border:1px solid var(--b); border-radius:14px;
    padding:20px; margin-bottom:12px; transition:border-color 0.2s;
  }
  .tf-prod-card.complete { border-color:var(--ab); }
  .tf-prod-card.optional-off { opacity:0.5; }

  .tf-summary-row { display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid var(--b); font-size:0.85rem; }
  .tf-summary-row:last-child { border-bottom:none; }
  .tf-summary-label { color:var(--td); }
  .tf-summary-val   { color:var(--t); font-weight:600; }

  .tf-deadline-banner {
    background:linear-gradient(135deg, rgba(245,158,11,0.1), rgba(245,158,11,0.05));
    border:1px solid rgba(245,158,11,0.25); border-radius:12px; padding:14px 18px;
    display:flex; align-items:center; gap:14px;
  }
  .tf-deadline-banner.urgent {
    background:linear-gradient(135deg, rgba(248,113,113,0.1), rgba(248,113,113,0.05));
    border-color:rgba(248,113,113,0.3);
    animation:tfDeadlinePulse 2s infinite;
  }
  @keyframes tfDeadlinePulse { 0%,100%{opacity:1} 50%{opacity:0.85} }

  .tf-celebrate {
    position:fixed; inset:0; z-index:300; display:flex; align-items:center; justify-content:center;
    background:rgba(0,0,0,0.85); backdrop-filter:blur(8px);
    animation:tfFadeIn 0.4s ease;
  }
  .tf-celebrate-inner { text-align:center; animation:tfSlideUp 0.5s var(--ease); }
  .tf-confetti { position:absolute; inset:0; pointer-events:none; }

  .tf-mobile-nav {
    position:sticky; bottom:0; background:var(--s1); border-top:1px solid var(--b);
    display:none; z-index:70;
  }
  @media(max-width:640px){
    .tf-mobile-nav { display:flex; }
    .tf-topbar-right { display:none; }
  }
  .tf-mobile-nav button { flex:1; padding:12px 8px; display:flex; flex-direction:column; align-items:center; gap:4px; font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.07em; color:var(--td); transition:color 0.2s; }
  .tf-mobile-nav button.on { color:var(--a); }
  .tf-mobile-nav button i { font-size:1.1rem; }

  @media(max-width:768px){
    .tf-dash-grid { grid-template-columns:1fr !important; }
    .tf-player-grid { grid-template-columns:repeat(3,1fr) !important; gap:8px !important; }
    .tf-kpi-strip { grid-template-columns:repeat(2,1fr) !important; }
  }
  @media(max-width:480px){
    .tf-player-grid { grid-template-columns:repeat(2,1fr) !important; }
    .tf-kpi-strip { grid-template-columns:1fr 1fr !important; }
  }

  .tf-prod-search-wrap { position:relative; }
  .tf-prod-results {
    position:absolute; top:calc(100% + 6px); left:0; right:0; z-index:50;
    background:var(--s2); border:1px solid var(--b2); border-radius:10px;
    max-height:280px; overflow-y:auto; box-shadow:0 16px 40px rgba(0,0,0,0.5);
  }
  .tf-prod-result {
    display:flex; align-items:center; gap:12px; padding:10px 14px;
    cursor:pointer; transition:background 0.15s; border-bottom:1px solid var(--b);
  }
  .tf-prod-result:last-child { border-bottom:none; }
  .tf-prod-result:hover { background:var(--s3); }
  .tf-prod-result img { width:44px; height:44px; object-fit:cover; border-radius:7px; border:1px solid var(--b); flex-shrink:0; }
  .tf-prod-result-name { font-size:0.83rem; font-weight:600; color:var(--t); }
  .tf-prod-result-price { font-size:0.72rem; color:var(--td); margin-top:2px; }

  .tf-roster-search-wrap { position:relative; }
  .tf-roster-search-ico { position:absolute; right:12px; top:50%; transform:translateY(-50%); color:var(--td); font-size:0.8rem; pointer-events:none; }

  .tf-pin-dots { display:flex; gap:12px; justify-content:center; margin:20px 0; }
  .tf-pin-dot { width:16px; height:16px; border-radius:50%; border:2px solid var(--b2); transition:all 0.2s ease; }
  .tf-pin-dot.filled { background:var(--a); border-color:var(--a); transform:scale(1.1); }

  .tf ::-webkit-scrollbar { width:4px; }
  .tf ::-webkit-scrollbar-thumb { background:var(--b2); border-radius:2px; }

  /* Cart button in topbar */
  .tf-cart-btn{position:relative;height:36px;padding:0 14px;border-radius:11px;background:var(--s3);border:1px solid var(--b);color:var(--tm);font-family:'Oswald',sans-serif;font-size:0.72rem;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;display:inline-flex;align-items:center;gap:7px;cursor:pointer;transition:all 0.2s;}
  .tf-cart-btn:hover{background:var(--s4);color:var(--t);}
  .tf-cart-btn.has-items{border-color:var(--ab);color:var(--a);}
  .tf-cart-badge{position:absolute;top:-6px;right:-6px;min-width:18px;height:18px;border-radius:9px;background:var(--a);color:#fff;font-size:0.6rem;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 4px;}
  /* Cart drawer */
  .tf-cart-drawer-ov{display:none;position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:150;backdrop-filter:blur(4px);}
  .tf-cart-drawer-ov.on{display:block;}
  .tf-cart-drawer{position:fixed;top:0;right:0;bottom:0;width:min(440px,100vw);background:var(--s1);border-left:1px solid var(--b);z-index:151;transform:translateX(100%);transition:transform 0.4s var(--ease);display:flex;flex-direction:column;}
  .tf-cart-drawer.on{transform:translateX(0);}
  .tf-cart-drw-bar{height:58px;padding:0 1.25rem;border-bottom:1px solid var(--b);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
  .tf-cart-drw-body{flex:1;overflow-y:auto;padding:1.25rem;}
  .tf-cart-drw-footer{padding:1.25rem;border-top:1px solid var(--b);flex-shrink:0;}
  .tf-cart-item{background:var(--s2);border:1px solid var(--b);border-radius:12px;padding:14px;margin-bottom:10px;}
  .tf-cart-item-team{font-size:0.6rem;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;color:var(--a);margin-bottom:6px;}
  .tf-cart-item-player{font-family:'Oswald',sans-serif;font-size:1rem;font-weight:700;text-transform:uppercase;margin-bottom:8px;}
  .tf-cart-item-product{display:flex;justify-content:space-between;font-size:0.78rem;color:var(--tm);margin-top:3px;}
  /* Gallery */
  .tf-gallery{display:flex;gap:8px;overflow-x:auto;padding-bottom:8px;margin-top:8px;}
  .tf-gallery-main{width:100%;aspect-ratio:1;border-radius:12px;object-fit:cover;border:1px solid var(--b);background:var(--s2);}
  .tf-gallery-thumb{width:56px;height:56px;border-radius:8px;object-fit:cover;border:1.5px solid var(--b);background:var(--s2);cursor:pointer;flex-shrink:0;transition:border-color 0.2s;}
  .tf-gallery-thumb.on{border-color:var(--a);}
  .tf-size-chart-badge{display:inline-flex;align-items:center;gap:5px;font-size:0.6rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;background:var(--ad);color:var(--a);border:1px solid var(--ab);border-radius:6px;padding:3px 8px;margin-bottom:8px;}
  .tf-prod-desc{font-size:0.78rem;color:var(--td);line-height:1.6;margin-top:10px;}
  .tf-prod-desc p{margin-bottom:8px;}
  .tf-prod-desc img{max-width:100%;border-radius:8px;margin:8px 0;}
  .tf-prod-desc table{width:100%;border-collapse:collapse;font-size:0.75rem;}
  .tf-prod-desc td,.tf-prod-desc th{padding:6px 10px;border:1px solid var(--b);text-align:left;}
  .tf-prod-desc th{background:var(--s2);color:var(--tm);font-weight:700;}
  .tf-player-card.queued{border-color:var(--ab);}

`;

const styleEl = document.createElement('style');
styleEl.textContent = CSS;
document.head.appendChild(styleEl);

// ── Config ───────────────────────────────────────────────────────────────────
const CFG        = window.TF_PORTAL || {};
const FB_CFG     = CFG.firebase || {};
const MASTER_PIN = CFG.masterPin || '123456';
const APP_ID     = CFG.appId || 'threadfueled-portal-live';
const fmtMoney   = (n) => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n||0);
const fmtDate    = (d) => d ? new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}) : '—';
const CART_ABANDON_HOURS = 2;

// ── Multi-player cart state ──────────────────────────────────────────────────
const multiCart = {};
function cartCount() { return Object.keys(multiCart).length; }
function cartTotal() { return Object.values(multiCart).reduce((s,e)=>s+e.items.reduce((ss,i)=>ss+i.price,0),0); }
let cartDrawerEl=null, cartOverlayEl=null, cartBtnEl=null;

function initCartDrawer() {
  cartOverlayEl=document.createElement('div'); cartOverlayEl.className='tf-cart-drawer-ov';
  cartOverlayEl.addEventListener('click',closeCartDrawer); document.body.appendChild(cartOverlayEl);
  cartDrawerEl=document.createElement('div'); cartDrawerEl.className='tf-cart-drawer';
  cartDrawerEl.innerHTML=`<div class="tf-cart-drw-bar"><div style="font-family:'Oswald',sans-serif;font-size:1rem;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;">Your Cart</div><button id="cartDrawerClose" class="tf-btn ghost sm"><i class="fa-solid fa-xmark"></i></button></div><div class="tf-cart-drw-body" id="cartDrawerBody"></div><div class="tf-cart-drw-footer" id="cartDrawerFooter"></div>`;
  cartDrawerEl.querySelector('#cartDrawerClose').addEventListener('click',closeCartDrawer);
  document.body.appendChild(cartDrawerEl);
}
function openCartDrawer() { renderCartDrawerContents(); cartOverlayEl.classList.add('on'); cartDrawerEl.classList.add('on'); document.body.style.overflow='hidden'; }
function closeCartDrawer() { cartOverlayEl.classList.remove('on'); cartDrawerEl.classList.remove('on'); document.body.style.overflow=''; }
function updateCartBtn() {
  if (!cartBtnEl) return;
  const c=cartCount(); cartBtnEl.classList.toggle('has-items',c>0);
  const b=cartBtnEl.querySelector('.tf-cart-badge'); if(b){b.textContent=c;b.style.display=c>0?'flex':'none';}
}
function renderCartDrawerContents() {
  const body=document.getElementById('cartDrawerBody'), footer=document.getElementById('cartDrawerFooter');
  if (!body||!footer) return;
  const entries=Object.values(multiCart);
  if (!entries.length) {
    body.innerHTML=`<div style="text-align:center;padding:60px 20px;color:var(--td);"><i class="fa-solid fa-cart-shopping" style="font-size:2rem;opacity:0.2;margin-bottom:14px;display:block;"></i><div style="font-size:0.85rem;">No players added yet.</div></div>`;
    footer.innerHTML=''; return;
  }
  body.innerHTML=entries.map(e=>`<div class="tf-cart-item"><div class="tf-cart-item-team">${e.teamName}</div><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;"><div class="tf-cart-item-player">#${e.playerNumber} ${e.playerName}</div><button class="tf-btn danger sm removeCartEntry" data-key="${e.teamId}_${e.playerId}" style="height:26px;padding:0 8px;font-size:0.6rem;"><i class="fa-solid fa-xmark"></i></button></div>${e.items.map(i=>`<div class="tf-cart-item-product"><span>${i.name}${i.size?' — '+i.size:''}</span><span style="color:var(--t);font-weight:600;">${fmtMoney(i.price)}</span></div>`).join('')}</div>`).join('');
  body.querySelectorAll('.removeCartEntry').forEach(btn=>{ btn.addEventListener('click',()=>{ delete multiCart[btn.dataset.key]; renderCartDrawerContents(); updateCartBtn(); }); });
  const total=cartTotal();
  footer.innerHTML=`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;"><span style="font-size:0.82rem;color:var(--td);">${entries.length} player${entries.length>1?'s':''}</span><span style="font-family:'Oswald',sans-serif;font-size:1.5rem;font-weight:700;color:var(--a);">${fmtMoney(total)}</span></div><div style="font-size:0.7rem;color:var(--td);margin-bottom:12px;line-height:1.5;"><i class="fa-solid fa-circle-info" style="margin-right:4px;color:var(--a);"></i>All players checkout together — one shipping charge, one tax calculation.</div><button id="cartCheckoutBtn" class="tf-btn prim full lg"><i class="fa-solid fa-lock"></i> Checkout — ${fmtMoney(total)}</button><button id="addMoreBtn" class="tf-btn ghost full" style="margin-top:8px;"><i class="fa-solid fa-plus"></i> Add Another Player</button>`;
  footer.querySelector('#cartCheckoutBtn').addEventListener('click',doMultiCartCheckout);
  footer.querySelector('#addMoreBtn').addEventListener('click',closeCartDrawer);
}

async function doMultiCartCheckout() {
  const btn=document.getElementById('cartCheckoutBtn');
  if(btn){btn.disabled=true;btn.innerHTML='<i class="fa-solid fa-spinner fa-spin"></i> Building cart…';}
  const entries=Object.values(multiCart);
  if (!entries.length) return;
  try {
    await fetch('/cart/clear.js',{method:'POST'});
    const allItems=[];
    const fsUpdates=[];
    entries.forEach(entry=>{
      entry.items.forEach(item=>{ if(item.variantId){ allItems.push({id:parseInt(item.variantId,10),quantity:1,properties:{'Player Name':entry.playerName,'Player Number':'#'+entry.playerNumber,'Team':entry.teamName}}); }});
      fsUpdates.push({teamId:entry.teamId,playerId:entry.playerId,orderDetails:JSON.stringify({sizes:entry.selectedSizes})});
    });
    await Promise.all(fsUpdates.map(async upd=>{
      const snap=await teamsRef().doc(upd.teamId).get(); if(!snap.exists) return;
      const roster=(snap.data().roster||[]).map(p=>p.id===upd.playerId?{...p,status:'in_cart',cartTimestamp:Date.now(),orderDetails:upd.orderDetails}:p);
      await teamsRef().doc(upd.teamId).update({roster});
    }));
    if(allItems.length) await addItemsToCart(allItems);
    const cartAttrPayload=JSON.stringify(entries.map(e=>({teamId:e.teamId,playerId:e.playerId,orderDetails:JSON.stringify({sizes:e.selectedSizes}),appId:APP_ID})));
    await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{tf_cart_entries:cartAttrPayload,tf_app_id:APP_ID}})});
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.location.href='/checkout';
  } catch(e) {
    await Promise.all(Object.values(multiCart).map(async entry=>{
      try { const snap=await teamsRef().doc(entry.teamId).get(); if(!snap.exists) return; const roster=(snap.data().roster||[]).map(p=>p.id===entry.playerId?{...p,status:'pending',cartTimestamp:null}:p); await teamsRef().doc(entry.teamId).update({roster}); } catch(e2){}
    }));
    toast('err','Checkout failed',e.message);
    if(btn){btn.disabled=false;btn.innerHTML=`<i class="fa-solid fa-lock"></i> Checkout — ${fmtMoney(cartTotal())}`;}
  }
}

function isSizeChartImage(img) {
  const s=(img.src||img||'').toLowerCase(), a=(img.alt||'').toLowerCase();
  return /size[-_]?chart|size[-_]?guide|sizing/.test(s+a);
}


// ── Firebase init ────────────────────────────────────────────────────────────
let db, auth, fbInitError;
try {
  if (!FB_CFG.apiKey) { fbInitError = 'Firebase API Key missing — check Theme Settings.'; }
  else if (typeof firebase !== 'undefined') {
    if (!firebase.apps.length) firebase.initializeApp(FB_CFG);
    db   = firebase.firestore();
    auth = firebase.auth();
  } else { fbInitError = 'Firebase SDK not loaded.'; }
} catch(e) { fbInitError = 'Firebase init failed: ' + e.message; }

const teamsRef = () => db.collection('artifacts').doc(APP_ID).collection('public').doc('data').collection('teams');

// ── Toast system ─────────────────────────────────────────────────────────────
let toastContainer;
function initToasts() {
  toastContainer = document.createElement('div');
  toastContainer.className = 'tf-toasts';
  document.body.appendChild(toastContainer);
}
function toast(type, title, body) {
  if (!toastContainer) initToasts();
  const icons = {ok:'fa-circle-check',err:'fa-circle-exclamation',info:'fa-circle-info',warn:'fa-triangle-exclamation'};
  const t = document.createElement('div');
  t.className = 'tf-toast';
  t.innerHTML = `<div class="tf-toast-ico ${type}"><i class="fa-solid ${icons[type]||'fa-circle-info'}"></i></div>
    <div><div class="tf-toast-title">${title}</div>${body?`<div class="tf-toast-body">${body}</div>`:''}</div>`;
  toastContainer.appendChild(t);
  setTimeout(() => {
    t.style.cssText = 'opacity:0;transform:translateX(110%);transition:all 0.3s ease;';
    setTimeout(() => t.remove(), 300);
  }, 5000);
}

// ── Modal system ─────────────────────────────────────────────────────────────
function showModal({ title, sub, body, btns, onClose }) {
  const ov = document.createElement('div');
  ov.className = 'tf-modal-ov';
  ov.innerHTML = `
    <div class="tf-modal">
      <div class="tf-modal-title">${title}</div>
      ${sub ? `<div class="tf-modal-sub">${sub}</div>` : ''}
      ${body || ''}
      <div class="tf-modal-btns"></div>
    </div>`;
  const btnRow = ov.querySelector('.tf-modal-btns');
  (btns || []).forEach(b => {
    const el = document.createElement('button');
    el.className = `tf-btn ${b.cls||'ghost'} ${b.full?'full':''}`;
    el.innerHTML = b.label;
    el.onclick = () => { ov.remove(); if(b.action) b.action(); };
    btnRow.appendChild(el);
  });
  ov.addEventListener('click', e => { if(e.target===ov){ ov.remove(); if(onClose) onClose(); } });
  document.addEventListener('keydown', function esc(e){ if(e.key==='Escape'){ ov.remove(); document.removeEventListener('keydown',esc); } });
  document.body.appendChild(ov);
  return ov;
}

// ── Confetti burst ────────────────────────────────────────────────────────────
function burstConfetti(container) {
  const colors = ['#0D9488','#34d399','#f59e0b','#60a5fa','#f472b6','#ffffff'];
  for (let i = 0; i < 80; i++) {
    const p = document.createElement('div');
    const color = colors[Math.floor(Math.random()*colors.length)];
    const size  = Math.random()*8+4;
    p.style.cssText = `position:absolute;width:${size}px;height:${size}px;background:${color};border-radius:${Math.random()>0.5?'50%':'2px'};left:${Math.random()*100}%;top:-10px;opacity:1;animation:tfConfetti${i} ${1.5+Math.random()*2}s ease-in forwards;`;
    const endX = (Math.random()-0.5)*400;
    const endY = 400+Math.random()*300;
    const rot  = Math.random()*720-360;
    const style = document.createElement('style');
    style.textContent = `@keyframes tfConfetti${i}{to{transform:translate(${endX}px,${endY}px) rotate(${rot}deg);opacity:0;}}`;
    document.head.appendChild(style);
    container.appendChild(p);
  }
}

// ── Shopify helpers ──────────────────────────────────────────────────────────
async function searchShopifyProducts(query) {
  try {
    const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`);
    if (!r.ok) return [];
    const d = await r.json();
    return (d.resources?.results?.products || []).map(p => ({
      id:p.id, name:p.title, handle:p.handle, image:p.image,
      price:p.price ? parseFloat(p.price.replace(/[^0-9.]/g,'')) : 0,
    }));
  } catch(e) { return []; }
}

async function fetchShopifyProduct(handle) {
  try {
    const r = await fetch(`/products/${handle}.js`);
    if (!r.ok) return null;
    const p = await r.json();
    return { id:p.id, name:p.title, price:p.price/100, image:p.featured_image, handle:p.handle, type:p.type, variants:p.variants };
  } catch(e) { return null; }
}

async function addItemsToCart(items) {
  const r = await fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({items}),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.description || data.message || `Cart error (${r.status})`);
  return data;
}

// ── Status helpers ───────────────────────────────────────────────────────────
function getEffectiveStatus(player) {
  if (player.status === 'paid') return 'paid';
  if (player.status === 'in_cart' && player.cartTimestamp) {
    const hours = (Date.now() - player.cartTimestamp) / (1000*60*60);
    if (hours > CART_ABANDON_HOURS) return 'pending';
  }
  return player.status || 'pending';
}

// =============================================================================
// LANDING PAGE
// =============================================================================
function renderLanding(root, nav) {
  nav({ title:'ThreadFueled Team Portal', showBack:false, showLogout:false });
  root.innerHTML = '';
  root.className = 'tf tf-screen tf-fade-in';

  const el = document.createElement('div');
  el.style.cssText = 'min-height:calc(100vh - 58px); display:flex; flex-direction:column;';
  el.innerHTML = `
    <div class="tf-bg"></div>
    <div style="padding:clamp(3rem,8vh,6rem) clamp(1.5rem,5vw,4rem) clamp(2rem,5vh,4rem); position:relative; z-index:1; flex:1; display:flex; flex-direction:column; justify-content:center; max-width:900px; margin:0 auto; width:100%;">
      <div style="font-family:'Oswald',sans-serif;font-size:0.72rem;font-weight:600;letter-spacing:0.3em;text-transform:uppercase;color:var(--a);margin-bottom:1.5rem;display:flex;align-items:center;gap:12px;">
        <span style="width:28px;height:2px;background:var(--a);display:block;"></span>
        ThreadFueled Team Portal
      </div>
      <h1 style="font-family:'Oswald',sans-serif;font-size:clamp(3.5rem,10vw,7rem);font-weight:700;line-height:0.9;text-transform:uppercase;letter-spacing:-0.02em;color:white;margin-bottom:1.5rem;">
        Build<br><span style="color:var(--a);">Your</span><br>Legacy.
      </h1>
      <p style="font-size:clamp(0.95rem,2vw,1.1rem);color:var(--td);line-height:1.65;max-width:44ch;margin-bottom:3rem;">
        Professional roster management and automated kit ordering — built for coaches and players who take their game seriously.
      </p>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;max-width:640px;" id="landingCards">
        <button id="managerBtn" style="background:var(--s1);border:1px solid var(--b);border-radius:16px;padding:28px 24px;text-align:left;transition:all 0.25s ease;position:relative;overflow:hidden;cursor:pointer;">
          <div style="position:absolute;left:0;top:0;bottom:0;width:3px;background:var(--a);border-radius:3px 0 0 3px;"></div>
          <div style="width:44px;height:44px;border-radius:10px;background:var(--ad);display:flex;align-items:center;justify-content:center;margin-bottom:16px;color:var(--a);">
            <i class="fa-solid fa-shield-halved" style="font-size:1.1rem;"></i>
          </div>
          <div style="font-family:'Oswald',sans-serif;font-size:1.1rem;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:white;margin-bottom:6px;">Team Manager</div>
          <div style="font-size:0.8rem;color:var(--td);line-height:1.5;margin-bottom:16px;">Configure roster, manage kit, track player orders.</div>
          <div style="font-family:'Oswald',sans-serif;font-size:0.72rem;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:var(--a);display:flex;align-items:center;gap:6px;">
            Manager Login <i class="fa-solid fa-arrow-right" style="font-size:0.7rem;"></i>
          </div>
        </button>
        <button id="playerBtn" style="background:var(--s1);border:1px solid var(--b);border-radius:16px;padding:28px 24px;text-align:left;transition:all 0.25s ease;position:relative;overflow:hidden;cursor:pointer;">
          <div style="position:absolute;left:0;top:0;bottom:0;width:3px;background:rgba(255,255,255,0.1);border-radius:3px 0 0 3px;transition:background 0.25s;"></div>
          <div style="width:44px;height:44px;border-radius:10px;background:var(--s2);display:flex;align-items:center;justify-content:center;margin-bottom:16px;color:var(--td);transition:all 0.25s;">
            <i class="fa-solid fa-shirt" style="font-size:1.1rem;"></i>
          </div>
          <div style="font-family:'Oswald',sans-serif;font-size:1.1rem;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:white;margin-bottom:6px;">Player Order</div>
          <div style="font-size:0.8rem;color:var(--td);line-height:1.5;margin-bottom:16px;">Find your roster spot, pick sizes, gear up.</div>
          <div style="font-family:'Oswald',sans-serif;font-size:0.72rem;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:var(--tm);display:flex;align-items:center;gap:6px;">
            Start Order <i class="fa-solid fa-arrow-right" style="font-size:0.7rem;"></i>
          </div>
        </button>
      </div>
      <div id="landingStats" style="display:flex;gap:24px;margin-top:3rem;padding-top:2rem;border-top:1px solid var(--b);">
        <div><div style="font-family:'Oswald',sans-serif;font-size:1.6rem;font-weight:700;color:white;" id="lsTeams">—</div><div style="font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:var(--td);margin-top:2px;">Active Teams</div></div>
        <div style="width:1px;background:var(--b);"></div>
        <div><div style="font-family:'Oswald',sans-serif;font-size:1.6rem;font-weight:700;color:var(--a);" id="lsOrders">—</div><div style="font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:var(--td);margin-top:2px;">Orders Placed</div></div>
        <div style="width:1px;background:var(--b);"></div>
        <div><div style="font-family:'Oswald',sans-serif;font-size:1.6rem;font-weight:700;color:var(--amber);" id="lsPending">—</div><div style="font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:var(--td);margin-top:2px;">Pending</div></div>
      </div>
    </div>
    <button id="adminGearBtn" style="position:fixed;bottom:20px;right:20px;width:40px;height:40px;background:var(--s2);border:1px solid var(--b);border-radius:50%;display:flex;align-items:center;justify-content:center;color:var(--td);transition:all 0.2s;z-index:10;" title="Admin">
      <i class="fa-solid fa-gear" style="font-size:0.9rem;"></i>
    </button>
  `;

  root.appendChild(el);

  if (db) {
    teamsRef().get().then(snap => {
      const teams = snap.docs.map(d => d.data());
      const totalOrders  = teams.reduce((s,t) => s + (t.roster||[]).filter(p=>p.status==='paid').length, 0);
      const totalPending = teams.reduce((s,t) => s + (t.roster||[]).filter(p=>getEffectiveStatus(p)==='pending').length, 0);
      const ls = el.querySelector('#lsTeams');   if(ls) ls.textContent = teams.length;
      const lo = el.querySelector('#lsOrders');  if(lo) lo.textContent = totalOrders;
      const lp = el.querySelector('#lsPending'); if(lp) lp.textContent = totalPending;
    }).catch(()=>{});
  }

  return {
    onManager: (cb) => el.querySelector('#managerBtn').addEventListener('click', cb),
    onPlayer:  (cb) => el.querySelector('#playerBtn').addEventListener('click', cb),
    onAdmin:   (cb) => el.querySelector('#adminGearBtn').addEventListener('click', cb),
  };
}

// =============================================================================
// MANAGER LOGIN
// =============================================================================
function renderManagerLogin(root, nav, onSuccess, onBack) {
  nav({ title:'Manager Access', showBack:true, onBack });
  root.innerHTML = '';
  root.className = 'tf tf-screen tf-fade-in';

  const wrap = document.createElement('div');
  wrap.style.cssText = 'min-height:calc(100vh - 58px);display:flex;align-items:center;justify-content:center;padding:2rem;';
  wrap.innerHTML = `
    <div class="tf-bg"></div>
    <div style="background:var(--s1);border:1px solid var(--b);border-radius:22px;padding:clamp(2rem,5vw,3.5rem);width:100%;max-width:460px;position:relative;z-index:1;box-shadow:0 40px 80px rgba(0,0,0,0.5);">
      <div style="width:56px;height:56px;border-radius:50%;border:2px solid var(--a);display:flex;align-items:center;justify-content:center;margin:0 auto 24px;color:var(--a);">
        <i class="fa-solid fa-shield-halved" style="font-size:1.3rem;"></i>
      </div>
      <div style="font-family:'Oswald',sans-serif;font-size:1.6rem;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;text-align:center;margin-bottom:6px;">Manager Access</div>
      <div style="font-size:0.82rem;color:var(--td);text-align:center;margin-bottom:32px;">Enter your team code and PIN to continue</div>
      <div class="tf-field">
        <label class="tf-label">Team Code</label>
        <input id="mgCode" class="tf-inp" type="text" placeholder="XXXXXX" maxlength="6" autocapitalize="characters" style="font-family:'Oswald',sans-serif;font-size:1.4rem;font-weight:700;letter-spacing:0.2em;text-transform:uppercase;text-align:center;">
      </div>
      <div class="tf-field" id="pinField">
        <label class="tf-label" id="pinLabel">Manager PIN</label>
        <input id="mgPin" class="tf-inp" type="password" placeholder="••••" style="font-size:1.2rem;letter-spacing:0.2em;text-align:center;">
        <div class="tf-pin-dots" id="pinDots">
          <div class="tf-pin-dot"></div><div class="tf-pin-dot"></div>
          <div class="tf-pin-dot"></div><div class="tf-pin-dot"></div>
        </div>
      </div>
      <div id="mgError" style="display:none;background:rgba(248,113,113,0.08);border:1px solid rgba(248,113,113,0.25);border-radius:9px;padding:10px 14px;font-size:0.8rem;font-weight:600;color:var(--red);margin-bottom:14px;"></div>
      <button id="mgLoginBtn" class="tf-btn prim full lg" style="width:100%;">
        <i class="fa-solid fa-right-to-bracket"></i>
        <span id="mgLoginTxt">Access Dashboard</span>
      </button>
    </div>
  `;
  root.appendChild(wrap);

  const codeEl  = wrap.querySelector('#mgCode');
  const pinEl   = wrap.querySelector('#mgPin');
  const errEl   = wrap.querySelector('#mgError');
  const btn     = wrap.querySelector('#mgLoginBtn');
  const pinDots = wrap.querySelectorAll('.tf-pin-dot');

  codeEl.focus();
  codeEl.addEventListener('input', e => { e.target.value = e.target.value.toUpperCase(); });
  pinEl.addEventListener('input', () => {
    const len = Math.min(pinEl.value.length, 4);
    pinDots.forEach((d,i) => d.classList.toggle('filled', i < len));
  });

  async function doLogin() {
    const code = codeEl.value.trim().toUpperCase();
    const pin  = pinEl.value;
    if (!code || !pin) { showErr('Please enter your team code and PIN.'); return; }
    if (!db) { showErr('Database not initialized.'); return; }
    btn.disabled = true;
    btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i><span>Checking…</span>';
    errEl.style.display = 'none';
    try {
      const snap = await teamsRef().where('code','==',code).get();
      if (snap.empty) { showErr('Team not found. Check your code.'); resetBtn(); return; }
      const doc  = snap.docs[0];
      const team = { id: doc.id, ...doc.data() };
      if (!team.adminPin) {
        if (pin.length < 4) { showErr('PIN must be at least 4 characters.'); resetBtn(); return; }
        await teamsRef().doc(team.id).update({ adminPin: pin });
        toast('ok', 'PIN Created', 'Welcome to your dashboard!');
        onSuccess(team.id);
      } else if (team.adminPin === pin) {
        onSuccess(team.id);
      } else {
        showErr('Incorrect PIN. Please try again.');
        pinEl.value = '';
        pinDots.forEach(d => d.classList.remove('filled'));
      }
    } catch(e) { showErr('Connection error. Please try again.'); }
    resetBtn();
  }

  function showErr(msg) { errEl.textContent = msg; errEl.style.display = 'block'; }
  function resetBtn() { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-right-to-bracket"></i><span>Access Dashboard</span>'; }

  btn.addEventListener('click', doLogin);
  pinEl.addEventListener('keypress', e => { if(e.key==='Enter') doLogin(); });
  codeEl.addEventListener('keypress', e => { if(e.key==='Enter') pinEl.focus(); });
}

// =============================================================================
// ADMIN PORTAL
// =============================================================================
function renderAdmin(root, nav, onBack) {
  nav({ title:'TF Admin', showBack:true, onBack });
  root.innerHTML = '';
  root.className = 'tf tf-screen tf-fade-in';

  let authed = false;
  let teams  = [];
  let unsub  = null;

  function renderAuthScreen() {
    root.innerHTML = `
      <div class="tf-bg"></div>
      <div style="min-height:calc(100vh - 58px);display:flex;align-items:center;justify-content:center;padding:2rem;">
        <div style="background:var(--s1);border:1px solid var(--b);border-radius:22px;padding:3rem;max-width:380px;width:100%;position:relative;z-index:1;">
          <div style="font-family:'Oswald',sans-serif;font-size:1.5rem;font-weight:700;text-transform:uppercase;text-align:center;margin-bottom:8px;">Admin Access</div>
          <div style="font-size:0.8rem;color:var(--td);text-align:center;margin-bottom:28px;">ThreadFueled internal only</div>
          <div class="tf-field">
            <label class="tf-label">Master PIN</label>
            <input id="adminPin" class="tf-inp" type="password" placeholder="••••••" style="text-align:center;font-size:1.3rem;letter-spacing:0.2em;">
          </div>
          <div id="adminErr" style="display:none;color:var(--red);font-size:0.78rem;font-weight:600;text-align:center;margin-bottom:12px;"></div>
          <button id="adminAuthBtn" class="tf-btn prim full"><i class="fa-solid fa-unlock"></i> Unlock</button>
        </div>
      </div>`;
    const pinEl = root.querySelector('#adminPin');
    const errEl = root.querySelector('#adminErr');
    pinEl.focus();
    function tryAuth() {
      if (pinEl.value === MASTER_PIN) { authed = true; renderDashboard(); }
      else { errEl.textContent = 'Incorrect PIN'; errEl.style.display = 'block'; pinEl.value = ''; }
    }
    root.querySelector('#adminAuthBtn').addEventListener('click', tryAuth);
    pinEl.addEventListener('keypress', e => { if(e.key==='Enter') tryAuth(); });
  }

  function renderDashboard() {
    root.innerHTML = `
      <div class="tf-bg"></div>
      <div style="max-width:1100px;margin:0 auto;padding:clamp(1.5rem,3vw,2.5rem);position:relative;z-index:1;">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:24px;">
          <div class="tf-sec-lbl">All Teams</div>
          <button id="newTeamBtn" class="tf-btn prim sm"><i class="fa-solid fa-plus"></i> New Team</button>
        </div>
        <div id="adminTeamsList" style="display:flex;flex-direction:column;gap:10px;">
          <div style="text-align:center;padding:40px;color:var(--td);font-size:0.85rem;">Loading teams…</div>
        </div>
      </div>
      <div id="newTeamPanel" style="display:none;position:fixed;inset:0;z-index:100;background:rgba(0,0,0,0.8);backdrop-filter:blur(6px);align-items:center;justify-content:center;padding:20px;">
        <div style="background:var(--s1);border:1px solid var(--b2);border-radius:20px;padding:32px;max-width:480px;width:100%;box-shadow:0 40px 80px rgba(0,0,0,0.6);">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:24px;">
            <div style="font-family:'Oswald',sans-serif;font-size:1.2rem;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;">Create New Team</div>
            <button id="closeNewTeam" class="tf-btn ghost sm"><i class="fa-solid fa-xmark"></i></button>
          </div>
          <div class="tf-field"><label class="tf-label">Team Name *</label><input id="ntName" class="tf-inp" placeholder="Eagles 14U" required></div>
          <div class="tf-fg2">
            <div class="tf-field"><label class="tf-label">Manager Email</label><input id="ntEmail" class="tf-inp" type="email" placeholder="coach@team.com"></div>
            <div class="tf-field"><label class="tf-label">Team Type</label>
              <select id="ntType" class="tf-sel"><option>Youth</option><option>Adult</option></select>
            </div>
          </div>
          <div id="ntErr" style="display:none;color:var(--red);font-size:0.78rem;font-weight:600;margin-bottom:12px;"></div>
          <button id="createTeamBtn" class="tf-btn prim full"><i class="fa-solid fa-paper-plane"></i> Create Team</button>
        </div>
      </div>
    `;

    if (unsub) unsub();
    unsub = teamsRef().orderBy('createdAt','desc').onSnapshot(snap => {
      teams = snap.docs.map(d => ({ id:d.id, ...d.data() }));
      renderTeamsList();
    });

    root.querySelector('#newTeamBtn').addEventListener('click', () => {
      root.querySelector('#newTeamPanel').style.display = 'flex';
    });
    root.querySelector('#closeNewTeam').addEventListener('click', () => {
      root.querySelector('#newTeamPanel').style.display = 'none';
    });
    root.querySelector('#createTeamBtn').addEventListener('click', async () => {
      const name  = root.querySelector('#ntName').value.trim();
      const email = root.querySelector('#ntEmail').value.trim();
      const type  = root.querySelector('#ntType').value;
      const errEl = root.querySelector('#ntErr');
      if (!name) { errEl.textContent = 'Team name is required.'; errEl.style.display = 'block'; return; }
      const code  = Math.random().toString(36).substring(2,8).toUpperCase();
      try {
        await teamsRef().add({
          name, teamType:type, managerEmail:email, code,
          adminPin:null, roster:[], kit:[],
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        root.querySelector('#newTeamPanel').style.display = 'none';
        root.querySelector('#ntName').value  = '';
        root.querySelector('#ntEmail').value = '';
        showModal({
          title:'Team Created!',
          sub:`Share this code with the team manager.`,
          body:`<div style="background:var(--s2);border:1px solid var(--b);border-radius:12px;padding:20px;text-align:center;margin-bottom:4px;">
            <div style="font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;color:var(--td);margin-bottom:8px;">Team Code</div>
            <div style="font-family:'Oswald',sans-serif;font-size:2.5rem;font-weight:700;letter-spacing:0.2em;color:var(--a);">${code}</div>
          </div>`,
          btns:[
            { label:'<i class="fa-solid fa-copy"></i> Copy Code', cls:'prim', full:true, action:() => { navigator.clipboard.writeText(code); toast('ok','Copied',code); } },
            { label:`<i class="fa-solid fa-envelope"></i> Email Manager`, cls:'ghost', full:true, action:() => {
              const sub  = encodeURIComponent('ThreadFueled Team Portal — Access Details');
              const body = encodeURIComponent(`Hi,\n\nYour team "${name}" is ready.\n\nTeam Code: ${code}\n\nPortal: ${window.location.href}\n\nYou'll be prompted to create your PIN on first login.\n\nThreadFueled`);
              window.open(`mailto:${email}?subject=${sub}&body=${body}`);
            }},
          ]
        });
        toast('ok','Team created', name + ' · Code: ' + code);
      } catch(e) { errEl.textContent = 'Error: ' + e.message; errEl.style.display = 'block'; }
    });
  }

  function renderTeamsList() {
    const list = root.querySelector('#adminTeamsList');
    if (!list) return;
    if (!teams.length) { list.innerHTML = '<div style="text-align:center;padding:60px;color:var(--td);">No teams yet.</div>'; return; }
    list.innerHTML = '';
    teams.forEach(team => list.appendChild(buildAdminTeamCard(team)));
  }

  function buildAdminTeamCard(team) {
    const paidCount    = (team.roster||[]).filter(p=>p.status==='paid').length;
    const totalPlayers = (team.roster||[]).length;
    const card = document.createElement('div');
    card.className = 'tf-card';
    card.style.cssText = 'padding:18px 20px;';
    card.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;">
        <div style="display:flex;align-items:center;gap:14px;flex:1;min-width:0;">
          <div style="width:44px;height:44px;border-radius:10px;background:var(--ad);display:flex;align-items:center;justify-content:center;color:var(--a);flex-shrink:0;">
            <i class="fa-solid fa-users" style="font-size:1rem;"></i>
          </div>
          <div style="min-width:0;">
            <div style="font-family:'Oswald',sans-serif;font-size:1rem;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${team.name}</div>
            <div style="font-size:0.72rem;color:var(--td);margin-top:3px;">
              Code: <span style="font-family:'Oswald',sans-serif;color:var(--a);font-weight:700;letter-spacing:0.12em;">${team.code}</span>
              &nbsp;·&nbsp; ${totalPlayers} players &nbsp;·&nbsp; ${paidCount} paid
              &nbsp;·&nbsp; PIN: ${team.adminPin ? '✓ Set' : '<span style="color:var(--amber);">Pending</span>'}
            </div>
          </div>
        </div>
        <div style="display:flex;gap:8px;flex-shrink:0;">
          <button class="tf-btn dark sm expandBtn"><i class="fa-solid fa-chevron-down"></i></button>
          <button class="tf-btn danger sm deleteBtn"><i class="fa-solid fa-trash"></i></button>
        </div>
      </div>
      <div class="expandPanel" style="display:none;margin-top:16px;padding-top:16px;border-top:1px solid var(--b);">
        ${buildProductManager(team)}
      </div>`;

    card.querySelector('.expandBtn').addEventListener('click', () => {
      const panel = card.querySelector('.expandPanel');
      const icon  = card.querySelector('.expandBtn i');
      const open  = panel.style.display === 'none';
      panel.style.display = open ? 'block' : 'none';
      icon.className = `fa-solid fa-chevron-${open?'up':'down'}`;
      if (open) bindProductManager(card, team);
    });

    card.querySelector('.deleteBtn').addEventListener('click', () => {
      showModal({
        title:'Delete Team?',
        sub:`This permanently deletes ${team.name} and all ${totalPlayers} roster players. Cannot be undone.`,
        btns:[
          { label:'Cancel', cls:'ghost' },
          { label:'<i class="fa-solid fa-trash"></i> Delete Forever', cls:'danger', action: async () => {
            try { await teamsRef().doc(team.id).delete(); toast('info', 'Team deleted', team.name); }
            catch(e) { toast('err','Delete failed',e.message); }
          }},
        ]
      });
    });

    return card;
  }

  function buildProductManager(team) {
    const kit = team.kit||[];
    return `
      <div style="margin-bottom:14px;">
        <div class="tf-sec-lbl">Kit Items (${kit.length})</div>
        <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:8px;margin-bottom:14px;" id="kitGrid_${team.id}">
          ${kit.map((item,idx) => `
            <div style="background:var(--s2);border:1px solid var(--b);border-radius:9px;padding:12px;position:relative;">
              <img src="${item.image||''}" style="width:100%;height:80px;object-fit:cover;border-radius:6px;margin-bottom:8px;background:var(--s3);" onerror="this.style.display='none'">
              <div style="font-size:0.78rem;font-weight:600;color:var(--t);margin-bottom:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${item.name}</div>
              <div style="font-size:0.68rem;color:var(--td);">${fmtMoney(item.price)}</div>
              <div style="display:flex;align-items:center;gap:6px;margin-top:8px;">
                <button class="tf-btn ${item.isOptional?'dark':'prim'} sm optBtn" data-idx="${idx}" style="flex:1;height:26px;font-size:0.6rem;padding:0 8px;">${item.isOptional?'Optional':'Required'}</button>
                <button class="tf-btn danger sm rmBtn" data-idx="${idx}" style="width:26px;height:26px;padding:0;"><i class="fa-solid fa-xmark" style="font-size:0.65rem;"></i></button>
              </div>
            </div>`).join('')}
        </div>
        <div class="tf-prod-search-wrap">
          <input id="prodSearch_${team.id}" class="tf-inp" placeholder="Search products to add…" autocomplete="off">
          <div id="prodResults_${team.id}" class="tf-prod-results" style="display:none;"></div>
        </div>
        <div style="font-size:0.68rem;color:var(--td);margin-top:6px;">Type a product name to search your Shopify catalog</div>
      </div>`;
  }

  function bindProductManager(card, team) {
    const searchEl  = card.querySelector(`#prodSearch_${team.id}`);
    const resultsEl = card.querySelector(`#prodResults_${team.id}`);
    if (!searchEl || searchEl._bound) return;
    searchEl._bound = true;

    let searchTimer;
    searchEl.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchEl.value.trim();
      if (q.length < 2) { resultsEl.style.display = 'none'; return; }
      searchTimer = setTimeout(async () => {
        const products = await searchShopifyProducts(q);
        if (!products.length) { resultsEl.innerHTML = '<div style="padding:14px;font-size:0.8rem;color:var(--td);text-align:center;">No products found</div>'; resultsEl.style.display = 'block'; return; }
        resultsEl.innerHTML = products.map(p => `
          <div class="tf-prod-result" data-handle="${p.handle}">
            <img src="${p.image||''}" onerror="this.src=''">
            <div><div class="tf-prod-result-name">${p.name}</div><div class="tf-prod-result-price">${fmtMoney(p.price)}</div></div>
          </div>`).join('');
        resultsEl.style.display = 'block';
        resultsEl.querySelectorAll('.tf-prod-result').forEach(r => {
          r.addEventListener('click', async () => {
            resultsEl.style.display = 'none'; searchEl.value = '';
            const prod = await fetchShopifyProduct(r.dataset.handle);
            if (!prod) { toast('err','Product not found'); return; }
            const newKit = [...(team.kit||[]), {...prod, isOptional:false}];
            await teamsRef().doc(team.id).update({kit:newKit});
            toast('ok','Product added', prod.name);
          });
        });
      }, 300);
    });

    document.addEventListener('click', e => {
      if (!searchEl.contains(e.target) && !resultsEl.contains(e.target)) resultsEl.style.display = 'none';
    });

    card.querySelectorAll('.optBtn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const idx = parseInt(btn.dataset.idx, 10);
        const newKit = [...team.kit];
        newKit[idx] = {...newKit[idx], isOptional: !newKit[idx].isOptional};
        await teamsRef().doc(team.id).update({kit:newKit});
        toast('ok', newKit[idx].isOptional ? 'Set to Optional':'Set to Required');
      });
    });
    card.querySelectorAll('.rmBtn').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.idx, 10);
        showModal({
          title:'Remove Item?',
          sub:`Remove "${team.kit[idx]?.name}" from the kit?`,
          btns:[
            {label:'Cancel',cls:'ghost'},
            {label:'<i class="fa-solid fa-trash"></i> Remove',cls:'danger',action:async()=>{
              const newKit = [...team.kit]; newKit.splice(idx,1);
              await teamsRef().doc(team.id).update({kit:newKit});
              toast('info','Item removed');
            }},
          ]
        });
      });
    });
  }

  renderAuthScreen();
  return () => { if (unsub) unsub(); };
}

// =============================================================================
// MANAGER DASHBOARD
// =============================================================================
function renderManagerDashboard(root, nav, teamId, onBack) {
  let teamData = null;
  let unsub    = null;
  let activeTab = 'roster';

  nav({ title:'Dashboard', showBack:true, onBack, extra:`
    <button id="exportBtn" class="tf-btn dark sm"><i class="fa-solid fa-download"></i> Export</button>
    <button id="logoutBtn" class="tf-btn ghost sm"><i class="fa-solid fa-right-from-bracket"></i> Logout</button>
  `});

  root.innerHTML = '';
  root.className = 'tf tf-screen';

  const container = document.createElement('div');
  container.style.cssText = 'min-height:calc(100vh - 58px); position:relative; z-index:1;';
  container.innerHTML = `
    <div class="tf-bg"></div>
    <div id="dashContent" style="max-width:1200px;margin:0 auto;padding:clamp(1rem,3vw,2rem);"></div>
    <div class="tf-mobile-nav" id="mobileNav">
      <button class="on" data-tab="roster"><i class="fa-solid fa-users"></i>Roster</button>
      <button data-tab="kit"><i class="fa-solid fa-shirt"></i>Kit</button>
      <button data-tab="settings"><i class="fa-solid fa-gear"></i>Settings</button>
    </div>`;
  root.appendChild(container);

  unsub = teamsRef().doc(teamId).onSnapshot(doc => {
    if (!doc.exists) { toast('err','Team not found'); onBack(); return; }
    teamData = { id:doc.id, ...doc.data() };
    renderDash();
  }, err => { toast('err','Connection error', err.message); });

  setTimeout(() => {
    const exportBtn = document.getElementById('exportBtn');
    const logoutBtn = document.getElementById('logoutBtn');
    if (exportBtn) exportBtn.addEventListener('click', () => exportCSV());
    if (logoutBtn) logoutBtn.addEventListener('click', () => { if(unsub) unsub(); onBack(); });
  }, 100);

  function renderDash() {
    const content = container.querySelector('#dashContent');
    if (!content || !teamData) return;

    const roster   = teamData.roster || [];
    const kit      = teamData.kit    || [];
    const paid     = roster.filter(p => p.status === 'paid').length;
    const inCart   = roster.filter(p => getEffectiveStatus(p) === 'in_cart').length;
    const pending  = roster.filter(p => getEffectiveStatus(p) === 'pending').length;
    const total    = roster.length;
    const kitTotal = kit.reduce((s,i) => s + i.price, 0);
    const revenue  = paid * kitTotal;
    const goalRev  = total * kitTotal;
    const pct      = total ? Math.round((paid/total)*100) : 0;
    const deadline = teamData.orderDeadline || null;
    const isOpen   = teamData.orderWindowOpen !== false;

    let deadlineHtml = '';
    if (deadline) {
      const msLeft   = new Date(deadline) - Date.now();
      const daysLeft = Math.ceil(msLeft / (1000*60*60*24));
      const urgent   = daysLeft <= 2;
      if (msLeft > 0) {
        deadlineHtml = `
          <div class="tf-deadline-banner ${urgent?'urgent':''}" style="margin-bottom:20px;">
            <i class="fa-solid fa-clock" style="font-size:1.2rem;color:${urgent?'var(--red)':'var(--amber)'};flex-shrink:0;"></i>
            <div style="flex:1;">
              <div style="font-family:'Oswald',sans-serif;font-size:0.8rem;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:${urgent?'var(--red)':'var(--amber)'};">
                ${urgent ? '⚠ Order window closing soon!' : 'Order deadline'}
              </div>
              <div style="font-size:0.78rem;color:var(--td);margin-top:3px;">
                ${daysLeft === 1 ? 'Closes tomorrow' : `${daysLeft} days remaining`} — ${fmtDate(deadline)}
              </div>
            </div>
            ${urgent ? `<div style="font-family:'Oswald',sans-serif;font-size:1.5rem;font-weight:700;color:var(--red);">${daysLeft}d</div>` : ''}
          </div>`;
      }
    }

    if (total > 0 && paid === total) {
      deadlineHtml = `
        <div style="background:linear-gradient(135deg,rgba(13,148,136,0.15),rgba(13,148,136,0.05));border:1px solid var(--ab);border-radius:12px;padding:16px 20px;margin-bottom:20px;display:flex;align-items:center;gap:14px;">
          <i class="fa-solid fa-trophy" style="font-size:1.5rem;color:var(--a);"></i>
          <div>
            <div style="font-family:'Oswald',sans-serif;font-size:0.9rem;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:var(--a);">All players ordered!</div>
            <div style="font-size:0.78rem;color:var(--td);margin-top:2px;">Every roster spot is confirmed. Ready for production.</div>
          </div>
        </div>`;
    }

    content.innerHTML = `
      ${deadlineHtml}
      <div class="tf-kpi-strip" style="display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:var(--b);border-radius:14px;overflow:hidden;margin-bottom:20px;">
        ${kpiCell('Team', `<span style="font-size:1.1rem;">${teamData.name}</span>`, `<span style="font-size:0.7rem;color:var(--td);">Code: <span style="font-family:'Oswald',sans-serif;color:var(--a);cursor:pointer;" id="copyCodeKpi">${teamData.code}</span></span>`, false)}
        ${kpiCell('Orders', `${paid}<span style="font-size:1rem;color:var(--td);">/${total}</span>`, progressMiniHtml(pct, pct===100?'var(--a)':pct>60?'var(--a)':'var(--amber)'), false)}
        ${kpiCell('Revenue', fmtMoney(revenue), `<span style="font-size:0.68rem;color:var(--td);">of ${fmtMoney(goalRev)}</span>`, true)}
        ${kpiCell('Outstanding', `<span style="${pending>0?'color:var(--amber)':''}">${pending}</span>`, `<span style="font-size:0.68rem;color:var(--td);">${inCart} in checkout</span>`, false)}
      </div>
      <div style="display:flex;gap:0;border-bottom:1px solid var(--b);margin-bottom:20px;" id="dashTabs">
        ${['roster','kit','settings'].map(t => `
          <button class="tabBtn ${activeTab===t?'activeTab':''}" data-tab="${t}" style="font-family:'Oswald',sans-serif;font-size:0.78rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;padding:12px 20px;border-bottom:2px solid ${activeTab===t?'var(--a)':'transparent'};color:${activeTab===t?'var(--a)':'var(--td)'};transition:all 0.2s;cursor:pointer;background:none;border-left:none;border-right:none;border-top:none;">
            ${t.charAt(0).toUpperCase()+t.slice(1)}${t==='roster'&&pending>0?`<span style="margin-left:7px;background:var(--amber);color:#000;font-size:0.58rem;padding:2px 6px;border-radius:20px;">${pending}</span>`:''}
          </button>`).join('')}
      </div>
      <div id="tabContent"></div>
    `;

    const codeEl = content.querySelector('#copyCodeKpi');
    if (codeEl) codeEl.addEventListener('click', () => {
      navigator.clipboard.writeText(teamData.code).then(() => toast('ok','Copied',teamData.code));
    });

    content.querySelectorAll('.tabBtn').forEach(btn => {
      btn.addEventListener('click', () => {
        activeTab = btn.dataset.tab;
        content.querySelectorAll('.tabBtn').forEach(b => {
          b.style.borderBottomColor = b.dataset.tab===activeTab ? 'var(--a)' : 'transparent';
          b.style.color             = b.dataset.tab===activeTab ? 'var(--a)' : 'var(--td)';
        });
        renderTab();
      });
    });

    const mobileNav = container.querySelector('#mobileNav');
    if (mobileNav) {
      mobileNav.querySelectorAll('button').forEach(btn => {
        btn.classList.toggle('on', btn.dataset.tab === activeTab);
        btn.addEventListener('click', () => {
          activeTab = btn.dataset.tab;
          mobileNav.querySelectorAll('button').forEach(b => b.classList.toggle('on', b.dataset.tab===activeTab));
          renderTab();
        });
      });
    }

    renderTab();
  }

  function kpiCell(label, value, sub, accent) {
    return `<div style="background:var(--s1);padding:18px 20px;">
      <div style="font-size:0.62rem;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;color:var(--td);margin-bottom:6px;">${label}</div>
      <div style="font-family:'Oswald',sans-serif;font-size:1.8rem;font-weight:700;line-height:1;color:${accent?'var(--a)':'white'};">${value}</div>
      <div style="margin-top:6px;">${sub}</div>
    </div>`;
  }

  function progressMiniHtml(pct, color) {
    return `<div class="tf-prog-track" style="margin-top:8px;"><div class="tf-prog-fill" style="width:${pct}%;background:${color};"></div></div>`;
  }

  function renderTab() {
    const content = container.querySelector('#tabContent');
    if (!content) return;
    if      (activeTab === 'roster')   renderRosterTab(content);
    else if (activeTab === 'kit')      renderKitTab(content);
    else if (activeTab === 'settings') renderSettingsTab(content);
  }

  function renderRosterTab(content) {
    const roster = teamData.roster || [];
    const kit    = teamData.kit    || [];

    content.innerHTML = `
      <div class="tf-card" style="padding:18px;margin-bottom:16px;">
        <div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;">
          <div style="flex:1;min-width:160px;">
            <label class="tf-label">Player Name</label>
            <input id="newPlayerName" class="tf-inp" placeholder="Enter name">
          </div>
          <div style="width:100px;">
            <label class="tf-label">Number</label>
            <input id="newPlayerNum" class="tf-inp" placeholder="00" style="font-family:'Oswald',sans-serif;font-weight:700;text-align:center;">
          </div>
          <button id="addPlayerBtn" class="tf-btn prim" style="flex-shrink:0;"><i class="fa-solid fa-plus"></i> Add</button>
        </div>
      </div>
      <div style="display:flex;gap:10px;align-items:center;margin-bottom:14px;flex-wrap:wrap;">
        <div class="tf-roster-search-wrap" style="flex:1;min-width:160px;">
          <input id="rosterSearch" class="tf-inp" placeholder="Search players…" style="padding-right:36px;">
          <i class="fa-solid fa-magnifying-glass tf-roster-search-ico"></i>
        </div>
        <div style="display:flex;gap:6px;">
          ${['all','paid','pending','in_cart'].map(f => `
            <button class="tf-btn dark sm filterBtn ${f==='all'?'on':''}" data-filter="${f}" style="${f==='all'?'border-color:var(--a);color:var(--a);':''}">
              ${f==='in_cart'?'In Cart':f.charAt(0).toUpperCase()+f.slice(1)}
            </button>`).join('')}
        </div>
      </div>
      <div class="tf-card" style="overflow:hidden;">
        <div style="overflow-x:auto;">
          <table style="width:100%;border-collapse:collapse;" id="rosterTable">
            <thead>
              <tr style="background:var(--s2);border-bottom:1px solid var(--b);">
                <th style="padding:12px 16px;font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:var(--td);text-align:left;width:60px;">#</th>
                <th style="padding:12px 8px;font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:var(--td);text-align:left;">Player</th>
                ${kit.map(k=>`<th style="padding:12px 8px;font-size:0.62rem;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:var(--td);text-align:left;min-width:100px;">${k.name.split(' ').slice(0,2).join(' ')}</th>`).join('')}
                <th style="padding:12px 8px;font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:var(--td);text-align:left;min-width:90px;">Status</th>
                <th style="padding:12px 16px;text-align:right;width:80px;"></th>
              </tr>
            </thead>
            <tbody id="rosterBody"></tbody>
          </table>
        </div>
      </div>
    `;

    let filterVal = 'all';
    let searchVal = '';

    function getFiltered() {
      return roster.filter(p => {
        const status = getEffectiveStatus(p);
        const matchF = filterVal==='all' || status===filterVal || (filterVal==='in_cart'&&status==='in_cart');
        const matchS = !searchVal || p.name.toLowerCase().includes(searchVal);
        return matchF && matchS;
      });
    }

    function renderRows() {
      const tbody = content.querySelector('#rosterBody');
      if (!tbody) return;
      const filtered = getFiltered();
      if (!filtered.length) {
        tbody.innerHTML = `<tr><td colspan="${3+kit.length}" style="padding:30px;text-align:center;color:var(--td);font-size:0.82rem;">No players found</td></tr>`;
        return;
      }
      tbody.innerHTML = '';
      filtered.forEach(player => {
        const status = getEffectiveStatus(player);
        let sizes = {};
        if (player.orderDetails) { try { sizes = JSON.parse(player.orderDetails).sizes || {}; } catch(e) {} }

        const tr = document.createElement('tr');
        tr.style.cssText = 'border-bottom:1px solid var(--b);transition:background 0.15s;';
        tr.addEventListener('mouseenter', () => tr.style.background = 'var(--s2)');
        tr.addEventListener('mouseleave', () => tr.style.background = '');

        const kitCols = kit.map(item => {
          let val = sizes[item.id];
          if (val && item.variants) {
            const v = item.variants.find(x => String(x.id) === String(val));
            if (v) val = v.title;
          }
          return `<td style="padding:12px 8px;font-family:'Oswald',sans-serif;font-size:0.88rem;font-weight:600;color:${val?(status==='paid'?'var(--t)':'var(--amber)'):'var(--td)'};" title="${val?(status==='paid'?'Confirmed':'Selected — not yet paid'):''}">${val||'—'}</td>`;
        }).join('');

        tr.innerHTML = `
          <td style="padding:12px 16px;font-family:'Oswald',sans-serif;font-size:1.2rem;font-weight:700;color:var(--td);">${player.number}</td>
          <td style="padding:12px 8px;">
            <div style="font-size:0.9rem;font-weight:600;color:var(--t);">${player.name}</div>
            ${player.orderNumber ? `<div style="font-size:0.65rem;color:var(--a);font-weight:700;margin-top:2px;">Order ${String(player.orderNumber).charAt(0)==='#'?'':'#'}${player.orderNumber}</div>` : ''}
            ${player.purchaserName ? `<div style="font-size:0.63rem;color:var(--td);margin-top:1px;">Paid by ${player.purchaserName}</div>` : ''}
            ${player.orderDate ? `<div style="font-size:0.65rem;color:var(--td);margin-top:2px;">${fmtDate(player.orderDate)}</div>` : ''}
          </td>
          ${kitCols}
          <td style="padding:12px 8px;">
            <div class="tf-status ${status}">${status==='in_cart'?'In Cart':status.charAt(0).toUpperCase()+status.slice(1)}</div>
          </td>
          <td style="padding:12px 16px;text-align:right;">
            <div style="display:flex;gap:6px;justify-content:flex-end;">
              ${status!=='paid' ? `<button class="tf-btn prim sm markPaidBtn" data-id="${player.id}" title="Mark as paid" style="height:28px;padding:0 10px;font-size:0.6rem;"><i class="fa-solid fa-check"></i></button>` : ''}
              <button class="tf-btn dark sm linkOrderBtn" data-id="${player.id}" title="Link Shopify order number" style="height:28px;padding:0 10px;font-size:0.6rem;"><i class="fa-solid fa-receipt"></i></button>
              ${status==='paid' ? `<button class="tf-btn dark sm resetBtn" data-id="${player.id}" title="Reset order" style="height:28px;padding:0 10px;font-size:0.6rem;"><i class="fa-solid fa-rotate-left"></i></button>` : ''}
              <button class="tf-btn danger sm removeBtn" data-id="${player.id}" style="height:28px;padding:0 10px;font-size:0.6rem;"><i class="fa-solid fa-trash"></i></button>
            </div>
          </td>`;
        tbody.appendChild(tr);
      });

      tbody.querySelectorAll('.markPaidBtn').forEach(btn => {
        btn.addEventListener('click', () => {
          const pl = (teamData.roster||[]).find(x=>x.id===btn.dataset.id);
          showModal({
            title:'Mark as Paid',
            sub:`Confirm payment for #${pl?.number} ${pl?.name}. Adding the Shopify order number lets you cross-reference later.`,
            body:`<div class="tf-field"><label class="tf-label">Shopify Order # (optional)</label><input id="mpOrderNo" class="tf-inp" placeholder="1234" value="${pl?.orderNumber||''}"></div>
                  <div class="tf-field"><label class="tf-label">Purchaser Name (optional)</label><input id="mpBuyer" class="tf-inp" placeholder="Parent's name if different" value="${pl?.purchaserName||''}"></div>`,
            btns:[
              {label:'Cancel',cls:'ghost'},
              {label:'<i class="fa-solid fa-check"></i> Mark Paid',cls:'prim'}
            ]
          });
          // Read inputs before the modal closes
          setTimeout(()=>{
            const ov=document.querySelector('.tf-modal-ov'); if(!ov) return;
            const btns=ov.querySelectorAll('.tf-modal-btns button');
            const confirmBtn=btns[btns.length-1];
            confirmBtn.onclick=async(ev)=>{
              ev.stopPropagation();
              const ono=ov.querySelector('#mpOrderNo')?.value.trim()||null;
              const buy=ov.querySelector('#mpBuyer')?.value.trim()||null;
              ov.remove();
              const updated=(teamData.roster||[]).map(p=>p.id===btn.dataset.id
                ? {...p, status:'paid', orderDate:new Date().toISOString(), orderNumber:ono, purchaserName:buy, cartTimestamp:null}
                : p);
              await teamsRef().doc(teamId).update({roster:updated});
              toast('ok','Marked as paid', ono?('Order #'+ono):'');
            };
          },30);
        });
      });

      tbody.querySelectorAll('.linkOrderBtn').forEach(btn => {
        btn.addEventListener('click', () => {
          const pl=(teamData.roster||[]).find(x=>x.id===btn.dataset.id);
          showModal({
            title:'Link Shopify Order',
            sub:`Attach a Shopify order number to #${pl?.number} ${pl?.name} so you can cross-reference the purchase.`,
            body:`<div class="tf-field"><label class="tf-label">Shopify Order #</label><input id="loOrderNo" class="tf-inp" placeholder="1234" value="${pl?.orderNumber||''}"></div>
                  <div class="tf-field"><label class="tf-label">Purchaser Name</label><input id="loBuyer" class="tf-inp" placeholder="Parent's name if different" value="${pl?.purchaserName||''}"></div>`,
            btns:[{label:'Cancel',cls:'ghost'},{label:'<i class="fa-solid fa-link"></i> Save',cls:'prim'}]
          });
          setTimeout(()=>{
            const ov=document.querySelector('.tf-modal-ov'); if(!ov) return;
            const btns=ov.querySelectorAll('.tf-modal-btns button');
            const saveBtn=btns[btns.length-1];
            saveBtn.onclick=async(ev)=>{
              ev.stopPropagation();
              const ono=ov.querySelector('#loOrderNo')?.value.trim()||null;
              const buy=ov.querySelector('#loBuyer')?.value.trim()||null;
              ov.remove();
              const updated=(teamData.roster||[]).map(p=>p.id===btn.dataset.id?{...p,orderNumber:ono,purchaserName:buy}:p);
              await teamsRef().doc(teamId).update({roster:updated});
              toast('ok','Order linked', ono?('#'+ono):'Cleared');
            };
          },30);
        });
      });
      tbody.querySelectorAll('.resetBtn').forEach(btn => {
        btn.addEventListener('click', () => {
          showModal({
            title:'Reset Order?',
            sub:'This allows the player to re-select sizes and go through checkout again.',
            btns:[
              {label:'Cancel',cls:'ghost'},
              {label:'<i class="fa-solid fa-rotate-left"></i> Reset',cls:'prim',action:async()=>{
                const updated = (teamData.roster||[]).map(p =>
                  p.id===btn.dataset.id ? {...p, status:'pending', orderDetails:null, orderDate:null, cartTimestamp:null, orderNumber:null, purchaserName:null} : p);
                await teamsRef().doc(teamId).update({roster:updated});
                toast('info','Order reset');
              }},
            ]
          });
        });
      });
      tbody.querySelectorAll('.removeBtn').forEach(btn => {
        btn.addEventListener('click', () => {
          const player = (teamData.roster||[]).find(p=>p.id===btn.dataset.id);
          showModal({
            title:'Remove Player?',
            sub:`Remove ${player?.name||'this player'} from the roster?`,
            btns:[
              {label:'Cancel',cls:'ghost'},
              {label:'<i class="fa-solid fa-trash"></i> Remove',cls:'danger',action:async()=>{
                const updated = (teamData.roster||[]).filter(p=>p.id!==btn.dataset.id);
                await teamsRef().doc(teamId).update({roster:updated});
                toast('info','Player removed');
              }},
            ]
          });
        });
      });
    }

    content.querySelector('#addPlayerBtn').addEventListener('click', async () => {
      const name = content.querySelector('#newPlayerName').value.trim();
      const num  = content.querySelector('#newPlayerNum').value.trim() || '00';
      if (!name) { toast('warn','Enter player name'); return; }
      const newPlayer = { id:crypto.randomUUID(), name, number:num, status:'pending', orderDetails:null, orderDate:null };
      const updated   = [...(teamData.roster||[]), newPlayer];
      await teamsRef().doc(teamId).update({roster:updated});
      content.querySelector('#newPlayerName').value = '';
      content.querySelector('#newPlayerNum').value  = '';
      toast('ok','Player added', name);
    });

    content.querySelector('#rosterSearch').addEventListener('input', e => {
      searchVal = e.target.value.toLowerCase().trim();
      renderRows();
    });

    content.querySelectorAll('.filterBtn').forEach(btn => {
      btn.addEventListener('click', () => {
        filterVal = btn.dataset.filter;
        content.querySelectorAll('.filterBtn').forEach(b => {
          b.style.borderColor = b.dataset.filter===filterVal ? 'var(--a)' : '';
          b.style.color       = b.dataset.filter===filterVal ? 'var(--a)' : '';
        });
        renderRows();
      });
    });

    renderRows();
  }

  function renderKitTab(content) {
    const kit = teamData.kit || [];
    content.innerHTML = `
      <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:12px;">
        ${kit.length ? kit.map((item,idx) => `
          <div class="tf-card" style="padding:16px;display:flex;gap:14px;align-items:flex-start;">
            <img src="${item.image||''}" style="width:64px;height:64px;object-fit:cover;border-radius:9px;border:1px solid var(--b);background:var(--s2);flex-shrink:0;" onerror="this.style.display='none'">
            <div style="flex:1;min-width:0;">
              <div style="font-size:0.88rem;font-weight:600;color:var(--t);margin-bottom:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${item.name}</div>
              <div style="font-size:0.75rem;color:var(--td);margin-bottom:8px;">${fmtMoney(item.price)} · ${item.variants?.length||0} variant${(item.variants?.length||0)!==1?'s':''}</div>
              <span class="tf-badge ${item.isOptional?'optional':'core'}">${item.isOptional?'Optional':'Required'}</span>
            </div>
          </div>`).join('') : `<div style="grid-column:1/-1;text-align:center;padding:40px;color:var(--td);">No kit items configured.</div>`}
      </div>`;
  }

  function renderSettingsTab(content) {
    const deadline = teamData.orderDeadline || '';
    const isOpen   = teamData.orderWindowOpen !== false;
    content.innerHTML = `
      <div style="max-width:500px;display:flex;flex-direction:column;gap:14px;">
        <div class="tf-card" style="padding:18px;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;">
            <div>
              <div style="font-family:'Oswald',sans-serif;font-size:0.88rem;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:3px;">Order Window</div>
              <div style="font-size:0.75rem;color:var(--td);">When closed, players cannot access the portal.</div>
            </div>
            <button id="orderWindowToggle" class="tf-btn ${isOpen?'prim':'dark'}" style="min-width:80px;">
              <i class="fa-solid fa-${isOpen?'lock-open':'lock'}"></i> ${isOpen?'Open':'Closed'}
            </button>
          </div>
        </div>
        <div class="tf-card" style="padding:18px;">
          <div style="font-family:'Oswald',sans-serif;font-size:0.88rem;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:10px;">Order Deadline</div>
          <div style="display:flex;gap:10px;align-items:center;">
            <input id="deadlineInput" type="date" class="tf-inp" value="${deadline?deadline.split('T')[0]:''}" style="flex:1;">
            <button id="saveDeadlineBtn" class="tf-btn prim sm">Save</button>
            ${deadline ? `<button id="clearDeadlineBtn" class="tf-btn ghost sm"><i class="fa-solid fa-xmark"></i></button>` : ''}
          </div>
          ${deadline ? `<div style="font-size:0.72rem;color:var(--td);margin-top:8px;">Current: ${fmtDate(deadline)}</div>` : ''}
        </div>
        <div class="tf-card" style="padding:18px;">
          <div style="font-family:'Oswald',sans-serif;font-size:0.88rem;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:10px;">Share with Players</div>
          <div style="background:var(--s2);border:1px solid var(--b);border-radius:9px;padding:12px 14px;font-family:'Oswald',sans-serif;font-size:1.2rem;font-weight:700;letter-spacing:0.15em;color:var(--a);text-align:center;margin-bottom:10px;">${teamData.code}</div>
          <div style="display:flex;gap:8px;">
            <button id="shareCodeBtn" class="tf-btn prim sm" style="flex:1;"><i class="fa-solid fa-copy"></i> Copy Code</button>
            <button id="shareLinkBtn" class="tf-btn dark sm" style="flex:1;"><i class="fa-solid fa-link"></i> Copy Link</button>
          </div>
        </div>
      </div>`;

    content.querySelector('#orderWindowToggle').addEventListener('click', async () => {
      await teamsRef().doc(teamId).update({orderWindowOpen:!isOpen});
      toast('ok', !isOpen?'Order window opened':'Order window closed');
    });
    content.querySelector('#saveDeadlineBtn').addEventListener('click', async () => {
      const val = content.querySelector('#deadlineInput').value;
      await teamsRef().doc(teamId).update({orderDeadline:val?new Date(val).toISOString():null});
      toast('ok','Deadline saved', val ? fmtDate(val) : 'Cleared');
    });
    const clearBtn = content.querySelector('#clearDeadlineBtn');
    if (clearBtn) clearBtn.addEventListener('click', async () => {
      await teamsRef().doc(teamId).update({orderDeadline:null});
      toast('info','Deadline cleared');
    });
    content.querySelector('#shareCodeBtn').addEventListener('click', () => {
      navigator.clipboard.writeText(teamData.code).then(() => toast('ok','Code copied',teamData.code));
    });
    content.querySelector('#shareLinkBtn').addEventListener('click', () => {
      navigator.clipboard.writeText(window.location.href).then(() => toast('ok','Link copied'));
    });
  }

  function exportCSV() {
    if (!teamData) return;
    const kit    = teamData.kit || [];
    const roster = teamData.roster || [];
    const headers = ['Number','Player Name','Status','Order Date','Shopify Order #','Purchaser',...kit.map(k=>k.name)];
    const rows    = roster.map(p => {
      let sizes = {};
      if (p.orderDetails) { try{ sizes=JSON.parse(p.orderDetails).sizes||{}; }catch(e){} }
      const kitCols = kit.map(item => {
        let val = sizes[item.id];
        if (val && item.variants) { const v=item.variants.find(x=>String(x.id)===String(val)); if(v) val=v.title; }
        return `"${val||''}"`;
      });
      return [`"${p.number}"`,`"${p.name}"`,`"${(getEffectiveStatus(p)||'').toUpperCase()}"`,`"${p.orderDate?fmtDate(p.orderDate):''}"`,`"${p.orderNumber||''}"`,`"${p.purchaserName||''}"`, ...kitCols].join(',');
    });
    const blob = new Blob([[headers.join(','),...rows].join('\n')],{type:'text/csv'});
    const url  = URL.createObjectURL(blob);
    const a    = Object.assign(document.createElement('a'),{href:url,download:`${teamData.name}_Roster.csv`});
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    toast('ok','Export downloaded', teamData.name + '_Roster.csv');
  }

  return () => { if(unsub) unsub(); };
}

// =============================================================================
// PLAYER PORTAL — team code entry
// =============================================================================
function renderPlayerEntry(root, nav, onTeamFound, onBack) {
  nav({ title:'Player Order', showBack:true, onBack });
  root.innerHTML = '';
  root.className = 'tf tf-screen tf-fade-in';

  const wrap = document.createElement('div');
  wrap.style.cssText = 'min-height:calc(100vh - 58px);display:flex;align-items:center;justify-content:center;padding:2rem;';
  wrap.innerHTML = `
    <div class="tf-bg"></div>
    <div style="width:100%;max-width:420px;position:relative;z-index:1;text-align:center;">
      <div style="font-family:'Oswald',sans-serif;font-size:clamp(2.5rem,8vw,4.5rem);font-weight:700;text-transform:uppercase;line-height:0.9;margin-bottom:1rem;">
        Enter Your<br><span style="color:var(--a);">Team Code</span>
      </div>
      <p style="font-size:0.88rem;color:var(--td);margin-bottom:2.5rem;line-height:1.6;">Your coach will provide the 6-digit code to access your team's order portal.</p>
      <input id="playerCode" class="tf-inp" type="text" placeholder="XXXXXX" maxlength="6" autocapitalize="characters"
        style="font-family:'Oswald',sans-serif;font-size:2.5rem;font-weight:700;letter-spacing:0.25em;text-transform:uppercase;text-align:center;height:72px;margin-bottom:14px;">
      <div id="playerErr" style="display:none;background:rgba(248,113,113,0.08);border:1px solid rgba(248,113,113,0.25);border-radius:9px;padding:10px;font-size:0.8rem;font-weight:600;color:var(--red);margin-bottom:14px;"></div>
      <button id="findTeamBtn" class="tf-btn prim full lg" style="width:100%;">
        <i class="fa-solid fa-magnifying-glass"></i>
        <span id="findBtnTxt">Find My Team</span>
      </button>
    </div>`;
  root.appendChild(wrap);

  const codeEl = wrap.querySelector('#playerCode');
  const errEl  = wrap.querySelector('#playerErr');
  const btn    = wrap.querySelector('#findTeamBtn');

  codeEl.focus();
  codeEl.addEventListener('input', e => { e.target.value = e.target.value.toUpperCase(); errEl.style.display='none'; });

  async function findTeam() {
    const code = codeEl.value.trim().toUpperCase();
    if (code.length < 4) { errEl.textContent='Please enter your full team code.'; errEl.style.display='block'; return; }
    btn.disabled = true;
    btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i><span>Searching…</span>';
    errEl.style.display = 'none';
    try {
      const snap = await teamsRef().where('code','==',code).get();
      if (snap.empty) { errEl.textContent="Team not found. Double-check your code."; errEl.style.display='block'; }
      else {
        const team = { id:snap.docs[0].id, ...snap.docs[0].data() };
        if (team.orderWindowOpen === false) {
          errEl.textContent = "Order window is currently closed. Contact your coach.";
          errEl.style.display = 'block';
        } else { onTeamFound(team); }
      }
    } catch(e) { errEl.textContent='Connection error. Please try again.'; errEl.style.display='block'; }
    btn.disabled = false;
    btn.innerHTML = '<i class="fa-solid fa-magnifying-glass"></i><span>Find My Team</span>';
  }

  btn.addEventListener('click', findTeam);
  codeEl.addEventListener('keypress', e => { if(e.key==='Enter') findTeam(); });
}

// =============================================================================
// PLAYER ROSTER GRID
// =============================================================================
function renderPlayerRoster(root, nav, team, onPlayerSelected, onBack) {
  nav({ title:team.name, showBack:true, onBack });
  root.innerHTML = '';
  root.className = 'tf tf-screen tf-fade-in';

  const roster = team.roster || [];
  const paid   = roster.filter(p => p.status==='paid').length;
  const total  = roster.length;
  const pct    = total ? Math.round(paid/total*100) : 0;

  const wrap = document.createElement('div');
  wrap.style.cssText = 'min-height:calc(100vh - 58px); position:relative; z-index:1;';
  wrap.innerHTML = `
    <div class="tf-bg"></div>
    <div style="max-width:800px;margin:0 auto;padding:clamp(1.5rem,4vw,3rem);">
      <div style="margin-bottom:2rem;">
        <div style="font-family:'Oswald',sans-serif;font-size:clamp(2rem,6vw,3.5rem);font-weight:700;text-transform:uppercase;line-height:1;margin-bottom:8px;">${team.name}</div>
        <div style="font-size:0.83rem;color:var(--td);margin-bottom:16px;">Select your roster spot to begin your order.</div>
        <div style="display:flex;align-items:center;gap:12px;">
          <div class="tf-prog-track" style="flex:1;"><div class="tf-prog-fill" style="width:${pct}%;"></div></div>
          <div style="font-size:0.72rem;font-weight:700;color:var(--td);white-space:nowrap;">${paid}/${total} ordered</div>
        </div>
      </div>
      ${cartCount()>0?`<div style="background:rgba(13,148,136,0.08);border:1px solid var(--ab);border-radius:12px;padding:12px 16px;margin-bottom:20px;display:flex;align-items:center;justify-content:space-between;gap:12px;"><div style="font-size:0.82rem;color:var(--a);font-weight:600;"><i class="fa-solid fa-cart-shopping" style="margin-right:8px;"></i>${cartCount()} player${cartCount()>1?'s':''} in cart — ${fmtMoney(cartTotal())}</div><button id="viewCartInline" class="tf-btn prim sm"><i class="fa-solid fa-eye"></i> View Cart</button></div>`:''}
      <div class="tf-player-grid" style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;" id="playerGrid">
        ${roster.map(player => {
          const status = getEffectiveStatus(player);
          const isDone = status === 'paid';
          const isCart = status === 'in_cart';
          const isQueued = !!multiCart[team.id+'_'+player.id];
          return `
            <div class="tf-player-card ${isDone?'done':''} ${isCart&&!isQueued?'in-cart':''} ${isQueued?'queued':''}" data-id="${player.id}">
              <div class="tf-player-num">${player.number}</div>
              <div class="tf-player-name">${player.name}</div>
              <div style="margin-top:8px;">
                ${isDone?`<span class="tf-badge paid">Ordered ✓</span>`:isQueued?`<span class="tf-badge core">In Cart ✓</span>`:isCart?`<span class="tf-badge in-cart">In Checkout</span>`:`<span style="font-size:0.65rem;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:var(--a);">Select →</span>`}
              </div>
            </div>`;
        }).join('')}
      </div>
      ${roster.length === 0 ? '<div style="text-align:center;padding:60px;color:var(--td);">No players on this roster yet.</div>' : ''}
    </div>`;

  root.appendChild(wrap);

  wrap.querySelectorAll('.tf-player-card:not(.done)').forEach(card => {
    card.addEventListener('click', () => {
      const player = roster.find(p => p.id === card.dataset.id);
      if (player && getEffectiveStatus(player) !== 'paid') onPlayerSelected(player);
    });
  });
}

// =============================================================================
// PLAYER CHECKOUT
// =============================================================================
function renderPlayerCheckout(root, nav, team, player, onBack) {
  nav({ title:`#${player.number} ${player.name}`, showBack:true, onBack });
  root.innerHTML = '';
  root.className = 'tf tf-screen tf-fade-in';

  const kit            = (team.kit || []).filter(item => item.variants && item.variants.length > 0);
  const mandatoryItems = kit.filter(i => !i.isOptional);
  const optionalItems  = kit.filter(i => i.isOptional);

  const state = {
    selectedSizes:    {},
    selectedOptional: {},
    currentStep:      0,
  };

  // Auto-select single-variant items
  kit.forEach(item => {
    if (item.variants && item.variants.length === 1) {
      state.selectedSizes[item.id] = String(item.variants[0].id);
    }
  });

  const allItems   = [...mandatoryItems, ...optionalItems];

  const wrap = document.createElement('div');
  wrap.style.cssText = 'min-height:calc(100vh - 58px); position:relative; z-index:1;';
  wrap.innerHTML = `
    <div class="tf-bg"></div>
    <div id="checkoutContent" style="max-width:680px;margin:0 auto;padding:clamp(1rem,4vw,2.5rem);"></div>`;
  root.appendChild(wrap);

  function renderStep() {
    const content = wrap.querySelector('#checkoutContent');
    if (!content) return;

    const progressHtml = `
      <div style="display:flex;align-items:center;gap:6px;margin-bottom:2rem;">
        ${allItems.map((_,i) => `
          <div style="flex:1;height:3px;border-radius:2px;background:${i<state.currentStep?'var(--a)':i===state.currentStep?'rgba(13,148,136,0.4)':'var(--b)'};transition:background 0.3s;"></div>
        `).join('')}
        <div style="flex:1;height:3px;border-radius:2px;background:${state.currentStep===allItems.length?'var(--a)':'var(--b)'};transition:background 0.3s;"></div>
      </div>`;

    if (state.currentStep < allItems.length) {
      const item       = allItems[state.currentStep];
      const isOptional = item.isOptional;
      const isSelected = !isOptional || state.selectedOptional[item.id];
      const isSingleV  = item.variants.length === 1;
      const selected   = state.selectedSizes[item.id];

      content.innerHTML = `
        ${progressHtml}
        <div class="tf-fade-in">
          <div style="display:flex;align-items:center;gap:10px;margin-bottom:1.5rem;">
            <span class="tf-badge ${isOptional?'optional':'core'}">${isOptional?'Optional':'Core Item'}</span>
            <span style="font-size:0.72rem;color:var(--td);">Step ${state.currentStep+1} of ${allItems.length}</span>
          </div>
          <div style="display:flex;gap:20px;align-items:flex-start;margin-bottom:1.5rem;flex-wrap:wrap;">
            <div style="width:120px;height:120px;border-radius:14px;background:var(--s2);border:1px solid var(--b);overflow:hidden;flex-shrink:0;">
              <img src="${item.image||''}" style="width:100%;height:100%;object-fit:cover;" onerror="this.parentElement.innerHTML='<div style=\'width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:var(--td)\'><i class=\'fa-solid fa-image fa-2x\'></i></div>'">
            </div>
            <div style="flex:1;min-width:0;">
              <div style="font-family:'Oswald',sans-serif;font-size:1.6rem;font-weight:700;text-transform:uppercase;line-height:1;margin-bottom:6px;">${item.name}</div>
              <div style="font-size:1rem;color:var(--a);font-weight:700;margin-bottom:10px;">${fmtMoney(item.price)}</div>
              ${isOptional ? `
                <label style="display:flex;align-items:center;gap:10px;cursor:pointer;padding:10px 14px;background:var(--s2);border:1.5px solid ${isSelected?'var(--a)':'var(--b)'};border-radius:9px;transition:all 0.2s;" id="optToggle">
                  <div style="width:20px;height:20px;border-radius:5px;background:${isSelected?'var(--a)':'var(--s3)'};border:1.5px solid ${isSelected?'var(--a)':'var(--b2)'};display:flex;align-items:center;justify-content:center;transition:all 0.2s;">
                    ${isSelected?'<i class="fa-solid fa-check" style="font-size:10px;color:white;"></i>':''}
                  </div>
                  <span style="font-size:0.85rem;font-weight:600;color:var(--t);">Add this item (+${fmtMoney(item.price)})</span>
                </label>` : ''}
            </div>
          </div>
          ${(isOptional && !isSelected) ? `
            <div style="text-align:center;padding:20px;color:var(--td);font-size:0.85rem;">Item not added — tap above to include it</div>
          ` : isSingleV ? `
            <div style="background:rgba(52,211,153,0.08);border:1px solid rgba(52,211,153,0.2);border-radius:10px;padding:14px 16px;display:flex;align-items:center;gap:10px;">
              <i class="fa-solid fa-circle-check" style="color:var(--green);font-size:1rem;"></i>
              <span style="font-size:0.85rem;font-weight:600;color:var(--green);">One Size — Auto Selected</span>
            </div>
          ` : `
            <div>
              <div style="font-size:0.72rem;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:var(--td);margin-bottom:12px;">Select your size</div>
              <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(80px,1fr));gap:8px;" id="sizeGrid">
                ${item.variants.map(v => `
                  <button class="tf-size-btn ${String(v.id)===selected?'on':''} ${!v.available?'unavail':''}" data-vid="${v.id}">
                    ${v.title}
                  </button>`).join('')}
              </div>
            </div>
          `}
          <div style="display:flex;gap:10px;margin-top:2rem;">
            ${state.currentStep > 0 ? `<button id="prevBtn" class="tf-btn ghost" style="flex:0 0 auto;"><i class="fa-solid fa-arrow-left"></i></button>` : ''}
            <button id="nextBtn" class="tf-btn prim full lg" style="flex:1;" ${!canProceed(item)?'disabled':''}>
              ${state.currentStep === allItems.length-1 ? '<i class="fa-solid fa-eye"></i> Review Order' : 'Continue <i class="fa-solid fa-arrow-right"></i>'}
            </button>
          </div>
        </div>`;

      const optToggle = content.querySelector('#optToggle');
      if (optToggle) {
        optToggle.addEventListener('click', () => {
          state.selectedOptional[item.id] = !state.selectedOptional[item.id];
          if (!state.selectedOptional[item.id]) delete state.selectedSizes[item.id];
          renderStep();
        });
      }

      content.querySelectorAll('.tf-size-btn:not(.unavail)').forEach(btn => {
        btn.addEventListener('click', () => {
          state.selectedSizes[item.id] = String(btn.dataset.vid);
          renderStep();
        });
      });

      const nextBtn = content.querySelector('#nextBtn');
      if (nextBtn) nextBtn.addEventListener('click', () => { state.currentStep++; renderStep(); });
      const prevBtn = content.querySelector('#prevBtn');
      if (prevBtn) prevBtn.addEventListener('click', () => { state.currentStep--; renderStep(); });

    } else {
      renderConfirmation(content, progressHtml);
    }
  }

  function canProceed(item) {
    if (item.isOptional && !state.selectedOptional[item.id]) return true;
    if (item.variants.length === 1) return true;
    return !!state.selectedSizes[item.id];
  }

  function renderConfirmation(content, progressHtml) {
    const selectedItems = allItems.filter(item => {
      if (item.isOptional && !state.selectedOptional[item.id]) return false;
      return true;
    });
    const total = selectedItems.reduce((s,i) => s+i.price, 0);
    const existingInCart = cartCount() > 0;

    content.innerHTML = `
      ${progressHtml}
      <div class="tf-fade-in">
        <div style="text-align:center;margin-bottom:2rem;">
          <div style="width:64px;height:64px;border-radius:50%;background:var(--ad);border:2px solid var(--a);display:flex;align-items:center;justify-content:center;margin:0 auto 16px;color:var(--a);">
            <i class="fa-solid fa-clipboard-check" style="font-size:1.3rem;"></i>
          </div>
          <div style="font-family:'Oswald',sans-serif;font-size:1.8rem;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;margin-bottom:6px;">Review Your Order</div>
          <div style="font-size:0.85rem;color:var(--td);">For <strong style="color:var(--t);">#${player.number} ${player.name}</strong> — ${team.name}</div>
        </div>
        <div class="tf-card" style="padding:0;overflow:hidden;margin-bottom:16px;">
          ${selectedItems.map(item => {
            let sizeName = '';
            const vid = state.selectedSizes[item.id];
            if (vid && item.variants) {
              const v = item.variants.find(x=>String(x.id)===String(vid));
              sizeName = v ? v.title : '';
            }
            return `
              <div class="tf-summary-row" style="padding:14px 18px;">
                <div style="display:flex;align-items:center;gap:12px;">
                  <img src="${item.image||''}" style="width:44px;height:44px;object-fit:cover;border-radius:7px;border:1px solid var(--b);background:var(--s2);" onerror="this.style.display='none'">
                  <div>
                    <div style="font-size:0.88rem;font-weight:600;color:var(--t);">${item.name}</div>
                    ${sizeName ? `<div style="font-size:0.72rem;color:var(--a);font-weight:600;margin-top:2px;">${sizeName}</div>` : '<div style="font-size:0.72rem;color:var(--td);">One Size</div>'}
                  </div>
                </div>
                <div style="font-weight:700;color:var(--t);">${fmtMoney(item.price)}</div>
              </div>`;
          }).join('')}
        </div>
        <div style="display:flex;justify-content:space-between;align-items:center;padding:16px 20px;background:var(--s2);border-radius:12px;margin-bottom:20px;border:1px solid var(--b);">
          <span style="font-family:'Oswald',sans-serif;font-size:1rem;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:var(--tm);">Order Total</span>
          <span style="font-family:'Oswald',sans-serif;font-size:2rem;font-weight:700;color:var(--a);">${fmtMoney(total)}</span>
        </div>
        ${existingInCart?`<div style="background:rgba(13,148,136,0.08);border:1px solid var(--ab);border-radius:10px;padding:12px 16px;margin-bottom:14px;font-size:0.78rem;color:var(--a);line-height:1.5;"><i class="fa-solid fa-users" style="margin-right:6px;"></i><strong>${cartCount()} player${cartCount()>1?'s are':' is'} already in your cart.</strong> Add this player and check out together — one shipping charge, one tax calculation.</div>`:''}
        <div style="display:flex;gap:10px;margin-bottom:8px;">
          <button id="backToSizesBtn" class="tf-btn ghost" style="flex:0 0 auto;"><i class="fa-solid fa-arrow-left"></i> Back</button>
          <button id="addToCartBtn" class="tf-btn prim full lg" style="flex:1;">
            <i class="fa-solid fa-cart-plus"></i> Add to Cart
          </button>
        </div>
        <button id="checkoutNowBtn" class="tf-btn dark full" style="margin-bottom:4px;">
          <i class="fa-solid fa-lock"></i> Add &amp; Check Out Now
        </button>
        <div style="font-size:0.7rem;color:var(--td);text-align:center;margin-top:8px;line-height:1.5;">
          <i class="fa-solid fa-circle-info" style="margin-right:4px;"></i>
          Ordering for more than one child? Add each player, then check out once.
        </div>
        <div id="checkoutErr" style="display:none;margin-top:12px;background:rgba(248,113,113,0.08);border:1px solid rgba(248,113,113,0.25);border-radius:9px;padding:10px;font-size:0.8rem;font-weight:600;color:var(--red);text-align:center;"></div>
      </div>`;

    content.querySelector('#backToSizesBtn').addEventListener('click', () => {
      state.currentStep = allItems.length - 1;
      renderStep();
    });

    // ── ADD TO CART (v3.3 — multi-player, with line item properties) ────────
    function buildCartEntry() {
      const items = selectedItems.map(item => {
        const vid = state.selectedSizes[item.id];
        let sizeName = '';
        if (vid && item.variants) {
          const v = item.variants.find(x => String(x.id) === String(vid));
          sizeName = v ? v.title : '';
        }
        return { id:item.id, variantId:vid||null, name:item.name, size:sizeName, price:item.price, image:item.image };
      });
      return {
        teamId:team.id, teamName:team.name,
        playerId:player.id, playerName:player.name, playerNumber:player.number,
        selectedSizes:Object.assign({}, state.selectedSizes),
        selectedOptional:Object.assign({}, state.selectedOptional),
        items
      };
    }

    function stashPlayer() {
      const key = team.id + '_' + player.id;
      multiCart[key] = buildCartEntry();
      updateCartBtn();
      return multiCart[key];
    }

    content.querySelector('#addToCartBtn').addEventListener('click', () => {
      stashPlayer();
      toast('ok', '#' + player.number + ' ' + player.name + ' added to cart',
        fmtMoney(total) + ' · ' + selectedItems.length + ' item' + (selectedItems.length !== 1 ? 's' : ''));
      onBack();
    });

    content.querySelector('#checkoutNowBtn').addEventListener('click', () => {
      stashPlayer();
      openCartDrawer();
    });
  }

  renderStep();
}

// =============================================================================
// TOPBAR / NAV SYSTEM
// =============================================================================
function buildTopbar(rootEl) {
  let topbar = document.getElementById('tf-topbar');
  if (!topbar) {
    topbar = document.createElement('div');
    topbar.id = 'tf-topbar';
    topbar.className = 'tf-topbar';
    rootEl.parentNode.insertBefore(topbar, rootEl);
  }
  return function nav({ title, showBack, onBack, extra }) {
    topbar.innerHTML = `
      <div style="display:flex;align-items:center;gap:12px;">
        ${showBack ? `<button id="topbarBack" class="tf-btn ghost sm" style="flex-shrink:0;"><i class="fa-solid fa-arrow-left"></i></button>` : ''}
        <div class="tf-brand">
          <div class="dot"></div>
          <span>${title || 'ThreadFueled'}</span>
        </div>
      </div>
      <div style="display:flex;gap:8px;align-items:center;" id="topbarRight">
        ${extra || ''}
        <button class="tf-cart-btn" id="topbarCartBtn"><i class="fa-solid fa-cart-shopping"></i> Cart<span class="tf-cart-badge" style="display:none;">0</span></button>
      </div>`;
    cartBtnEl = topbar.querySelector('#topbarCartBtn');
    if (cartBtnEl) cartBtnEl.addEventListener('click', openCartDrawer);
    updateCartBtn();
    if (showBack && onBack) {
      topbar.querySelector('#topbarBack').addEventListener('click', onBack);
    }
  };
}

// =============================================================================
// ROOT APP
// =============================================================================
(function initApp() {
  const portalRoot = document.getElementById('tf-portal-root');
  if (!portalRoot) return;

  if (typeof firebase === 'undefined') {
    setTimeout(initApp, 200);
    return;
  }

  const rootEl = document.createElement('div');
  rootEl.className = 'tf';
  portalRoot.appendChild(rootEl);

  const nav = buildTopbar(rootEl);
  initCartDrawer();
  let cleanupFn = null;

  function cleanup() { if (cleanupFn) { cleanupFn(); cleanupFn = null; } }

  if (fbInitError) {
    rootEl.innerHTML = `
      <div class="tf-bg"></div>
      <div style="min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:2rem;text-align:center;position:relative;z-index:1;">
        <i class="fa-solid fa-triangle-exclamation" style="font-size:2.5rem;color:var(--red);margin-bottom:16px;"></i>
        <div style="font-family:'Oswald',sans-serif;font-size:1.3rem;font-weight:700;text-transform:uppercase;margin-bottom:8px;">Configuration Error</div>
        <div style="font-size:0.85rem;color:var(--td);max-width:420px;line-height:1.6;">${fbInitError}</div>
      </div>`;
    return;
  }

  auth.signInAnonymously()
    .then(() => bootApp())
    .catch(err => {
      rootEl.innerHTML = `
        <div class="tf-bg"></div>
        <div style="min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:2rem;text-align:center;position:relative;z-index:1;">
          <i class="fa-solid fa-wifi" style="font-size:2rem;color:var(--red);margin-bottom:14px;"></i>
          <div style="font-family:'Oswald',sans-serif;font-size:1.1rem;font-weight:700;text-transform:uppercase;margin-bottom:8px;">Auth Failed</div>
          <div style="font-size:0.82rem;color:var(--td);max-width:380px;">${err.message}</div>
        </div>`;
    });

  function bootApp() {
    function goLanding() {
      cleanup();
      const handlers = renderLanding(rootEl, nav);
      handlers.onManager(() => goManagerLogin());
      handlers.onPlayer(()  => goPlayerEntry());
      handlers.onAdmin(()   => goAdmin());
    }
    function goManagerLogin() {
      cleanup();
      renderManagerLogin(rootEl, nav, (teamId) => goManagerDash(teamId), () => goLanding());
    }
    function goManagerDash(teamId) {
      cleanup();
      cleanupFn = renderManagerDashboard(rootEl, nav, teamId, () => goLanding());
    }
    function goAdmin() {
      cleanup();
      cleanupFn = renderAdmin(rootEl, nav, () => goLanding());
    }
    function goPlayerEntry() {
      cleanup();
      renderPlayerEntry(rootEl, nav, (team) => goPlayerRoster(team), () => goLanding());
    }
    function goPlayerRoster(team) {
      cleanup();
      renderPlayerRoster(rootEl, nav, team, (player) => goPlayerCheckout(team, player), () => goPlayerEntry());
    }
    function goPlayerCheckout(team, player) {
      cleanup();
      renderPlayerCheckout(rootEl, nav, team, player, () => goPlayerRoster(team));
    }
    goLanding();
  }

  initToasts();
})();

})(); // end IIFE